import * as i2$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, HostListener, inject, ViewChild, Optional, NgModule, Injectable, InjectionToken, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import * as i5 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i2 from '@spartacus/core';
import { GlobalMessageType, RoutingService, UrlModule, I18nModule, FeaturesConfigModule, provideDefaultConfig, AuthGuard, OAuthFlow, NotAuthGuard, AuthConfigService, GlobalMessageService, FeatureConfigService, useFeatureStyles, HttpErrorModel, AuthService, AuthRedirectService, provideDefaultConfigFactory, UserAddressService, AnonymousConsentsService, AnonymousConsentsConfig, ClientAuthenticationTokenService } from '@spartacus/core';
import * as i4 from '@spartacus/storefront';
import { ICON_TYPE, DIALOG_TYPE, LAUNCH_CALLER, IconModule, SpinnerModule, KeyboardFocusModule, BtnLikeLinkModule, CustomFormValidators, FormErrorsModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent, sortTitles, CaptchaModule, NgSelectA11yModule, PasswordVisibilityToggleModule, MessageComponentModule, getAddressNumbers, CardModule, PageSlotModule, LaunchDialogService } from '@spartacus/storefront';
import { BehaviorSubject, Subscription, combineLatest, Subject, map as map$1, filter as filter$1 } from 'rxjs';
import { first, take, tap, map, filter, switchMap } from 'rxjs/operators';
import * as i1 from '@spartacus/user/profile/root';
import { UserPasswordFacade, UserRegisterFacade, UserProfileFacade, UserEmailFacade } from '@spartacus/user/profile/root';
import * as i3 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule, UntypedFormBuilder, FormsModule } from '@angular/forms';
import * as i6 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { VerificationTokenFacade } from '@spartacus/user/account/root';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function CloseAccountModalComponent_ng_container_0_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 10);
    i0.ɵɵelement(2, "cx-spinner");
    i0.ɵɵelementEnd()();
  }
}
function CloseAccountModalComponent_ng_container_0_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "p", 12);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 13)(5, "button", 14);
    i0.ɵɵlistener("click", function CloseAccountModalComponent_ng_container_0_ng_template_14_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.closeAccount());
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 15);
    i0.ɵɵlistener("click", function CloseAccountModalComponent_ng_container_0_ng_template_14_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.dismissModal("Cancel"));
    });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "closeAccount.confirmAccountClosureMessage"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 5, "closeAccount.closeMyAccount"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 7, "common.cancel"), " ");
  }
}
function CloseAccountModalComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵlistener("esc", function CloseAccountModalComponent_ng_container_0_Template_div_esc_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.dismissModal("Escape click"));
    });
    i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "h3", 5);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 6);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵlistener("click", function CloseAccountModalComponent_ng_container_0_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.dismissModal("Cross click"));
    });
    i0.ɵɵelementStart(10, "span", 7);
    i0.ɵɵelement(11, "cx-icon", 8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(12, CloseAccountModalComponent_ng_container_0_div_12_Template, 3, 0, "div", 9);
    i0.ɵɵpipe(13, "async");
    i0.ɵɵtemplate(14, CloseAccountModalComponent_ng_container_0_ng_template_14_Template, 11, 9, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const loaded_r4 = i0.ɵɵreference(15);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFocus", ctx_r1.focusConfig);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 7, "closeAccount.confirmAccountClosure"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(8, 9, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(9, 11, "common.close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(13, 13, ctx_r1.isLoading$))("ngIfElse", loaded_r4);
  }
}
const _c0 = ["element"];
const _c1 = () => ({
  cxRoute: "home"
});
function CloseAccountComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 6);
    i0.ɵɵlistener("click", function CloseAccountComponent_ng_container_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.navigateTo("home"));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "common.cancel"), " ");
  }
}
function CloseAccountComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 7);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction0(6, _c1)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "common.cancel"));
  }
}
const _c2 = a0 => ({
  label: a0
});
const _c3 = () => ({
  cxRoute: "login"
});
function ForgotPasswordComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 8);
  }
}
function ForgotPasswordComponent_cx_form_errors_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 9);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "forgottenPassword.emailAddress.label")))("control", ctx_r0.form.get("userEmail"));
  }
}
function ForgotPasswordComponent_cx_form_errors_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.form.get("userEmail"));
  }
}
function ForgotPasswordComponent_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 11);
    i0.ɵɵlistener("click", function ForgotPasswordComponent_ng_container_13_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.navigateTo("login"));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "common.cancel"), " ");
  }
}
function ForgotPasswordComponent_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 12);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction0(6, _c3)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "common.cancel"));
  }
}
const _c4 = () => ({});
const _c5 = () => ({
  cxRoute: "termsAndConditions"
});
function RegisterComponent_section_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 34);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function RegisterComponent_section_0_cx_form_errors_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 35);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.firstName.label")))("control", ctx_r1.registerForm.get("firstName"));
  }
}
function RegisterComponent_section_0_cx_form_errors_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 31);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("firstName"));
  }
}
function RegisterComponent_section_0_cx_form_errors_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 36);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.lastName.label")))("control", ctx_r1.registerForm.get("lastName"));
  }
}
function RegisterComponent_section_0_cx_form_errors_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 31);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("lastName"));
  }
}
function RegisterComponent_section_0_cx_form_errors_43_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.emailAddress.label")))("control", ctx_r1.registerForm.get("email"));
  }
}
function RegisterComponent_section_0_cx_form_errors_44_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 31);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("email"));
  }
}
function RegisterComponent_section_0_cx_form_errors_57_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 38);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.password.label")))("control", ctx_r1.registerForm.get("password"));
  }
}
function RegisterComponent_section_0_cx_form_errors_58_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 31);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("password"));
  }
}
function RegisterComponent_section_0_cx_form_errors_68_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 39);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.confirmPassword.label")))("control", ctx_r1.registerForm.get("passwordconf"));
  }
}
function RegisterComponent_section_0_cx_form_errors_69_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 31);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("passwordconf"));
  }
}
function RegisterComponent_section_0_ng_container_72_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵelement(1, "input", 40);
    i0.ɵɵelementStart(2, "span", 27);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const anonymousConsent_r3 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r1.isConsentGiven(anonymousConsent_r3.consent));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", anonymousConsent_r3.template, " ");
  }
}
function RegisterComponent_section_0_ng_container_72_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, RegisterComponent_section_0_ng_container_72_label_1_Template, 4, 2, "label", 24);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const anonymousConsent_r3 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", anonymousConsent_r3.template);
  }
}
function RegisterComponent_section_0_div_74_div_1_div_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-form-required-asterisks");
    i0.ɵɵelementContainerEnd();
  }
}
function RegisterComponent_section_0_div_74_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label")(2, "input", 44);
    i0.ɵɵlistener("change", function RegisterComponent_section_0_div_74_div_1_div_1_Template_input_change_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const i_r5 = i0.ɵɵnextContext().index;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.updateAdditionalConsents($event, i_r5));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 27);
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, RegisterComponent_section_0_div_74_div_1_div_1_ng_container_5_Template, 2, 0, "ng-container", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "cx-form-errors", 31);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const id_r6 = ctx.ngIf;
    const ctx_r6 = i0.ɵɵnextContext();
    const control_r8 = ctx_r6.$implicit;
    const i_r5 = ctx_r6.index;
    const consents_r9 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("required", consents_r9[i_r5].required)("name", id_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", consents_r9[i_r5].template.description, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", consents_r9[i_r5].required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", control_r8.get("isConsentGranted"));
  }
}
function RegisterComponent_section_0_div_74_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtemplate(1, RegisterComponent_section_0_div_74_div_1_div_1_Template, 7, 5, "div", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r5 = ctx.index;
    const consents_r9 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("formGroupName", i_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", consents_r9[i_r5] == null ? null : consents_r9[i_r5].template == null ? null : consents_r9[i_r5].template.id);
  }
}
function RegisterComponent_section_0_div_74_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtemplate(1, RegisterComponent_section_0_div_74_div_1_Template, 2, 2, "div", 42);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.additionalConsents.controls);
  }
}
function RegisterComponent_section_0_cx_form_errors_87_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 45);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.termsAndConditions")))("control", ctx_r1.registerForm.get("termsandconditions"));
  }
}
function RegisterComponent_section_0_cx_form_errors_88_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 31);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("termsandconditions"));
  }
}
function RegisterComponent_section_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 2);
    i0.ɵɵtemplate(1, RegisterComponent_section_0_div_1_Template, 2, 3, "div", 3);
    i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "div", 6);
    i0.ɵɵelement(5, "cx-form-required-legend");
    i0.ɵɵelementStart(6, "form", 7);
    i0.ɵɵlistener("ngSubmit", function RegisterComponent_section_0_Template_form_ngSubmit_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.submitForm());
    });
    i0.ɵɵelementStart(7, "div", 8)(8, "label")(9, "span", 9);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "ng-select", 10);
    i0.ɵɵpipe(13, "async");
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 8)(16, "label")(17, "span", 9);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵelement(20, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(21, "input", 11);
    i0.ɵɵpipe(22, "cxTranslate");
    i0.ɵɵtemplate(23, RegisterComponent_section_0_cx_form_errors_23_Template, 2, 6, "cx-form-errors", 12)(24, RegisterComponent_section_0_cx_form_errors_24_Template, 1, 1, "cx-form-errors", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(25, "div", 8)(26, "label")(27, "span", 9);
    i0.ɵɵtext(28);
    i0.ɵɵpipe(29, "cxTranslate");
    i0.ɵɵelement(30, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(31, "input", 14);
    i0.ɵɵpipe(32, "cxTranslate");
    i0.ɵɵtemplate(33, RegisterComponent_section_0_cx_form_errors_33_Template, 2, 6, "cx-form-errors", 15)(34, RegisterComponent_section_0_cx_form_errors_34_Template, 1, 1, "cx-form-errors", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(35, "div", 8)(36, "label")(37, "span", 9);
    i0.ɵɵtext(38);
    i0.ɵɵpipe(39, "cxTranslate");
    i0.ɵɵelement(40, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(41, "input", 16);
    i0.ɵɵpipe(42, "cxTranslate");
    i0.ɵɵtemplate(43, RegisterComponent_section_0_cx_form_errors_43_Template, 2, 6, "cx-form-errors", 17)(44, RegisterComponent_section_0_cx_form_errors_44_Template, 1, 1, "cx-form-errors", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(45, "div", 8)(46, "label")(47, "span", 9);
    i0.ɵɵtext(48);
    i0.ɵɵpipe(49, "cxTranslate");
    i0.ɵɵelement(50, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(51, "input", 18);
    i0.ɵɵpipe(52, "cxTranslate");
    i0.ɵɵpipe(53, "cxTranslate");
    i0.ɵɵelementStart(54, "p", 19);
    i0.ɵɵtext(55);
    i0.ɵɵpipe(56, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(57, RegisterComponent_section_0_cx_form_errors_57_Template, 2, 6, "cx-form-errors", 20)(58, RegisterComponent_section_0_cx_form_errors_58_Template, 1, 1, "cx-form-errors", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(59, "div", 8)(60, "label")(61, "span", 9);
    i0.ɵɵtext(62);
    i0.ɵɵpipe(63, "cxTranslate");
    i0.ɵɵelement(64, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(65, "input", 21);
    i0.ɵɵpipe(66, "cxTranslate");
    i0.ɵɵpipe(67, "cxTranslate");
    i0.ɵɵtemplate(68, RegisterComponent_section_0_cx_form_errors_68_Template, 2, 6, "cx-form-errors", 22)(69, RegisterComponent_section_0_cx_form_errors_69_Template, 1, 1, "cx-form-errors", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(70, "div", 8)(71, "div", 23);
    i0.ɵɵtemplate(72, RegisterComponent_section_0_ng_container_72_Template, 2, 1, "ng-container", 24);
    i0.ɵɵpipe(73, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(74, RegisterComponent_section_0_div_74_Template, 2, 1, "div", 25);
    i0.ɵɵelementStart(75, "div", 8)(76, "div", 23)(77, "label");
    i0.ɵɵelement(78, "input", 26);
    i0.ɵɵelementStart(79, "span", 27);
    i0.ɵɵtext(80);
    i0.ɵɵpipe(81, "cxTranslate");
    i0.ɵɵelementStart(82, "a", 28);
    i0.ɵɵpipe(83, "cxUrl");
    i0.ɵɵtext(84);
    i0.ɵɵpipe(85, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(86, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(87, RegisterComponent_section_0_cx_form_errors_87_Template, 2, 6, "cx-form-errors", 29)(88, RegisterComponent_section_0_cx_form_errors_88_Template, 1, 1, "cx-form-errors", 13);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(89, "cx-captcha", 30);
    i0.ɵɵlistener("confirmed", function RegisterComponent_section_0_Template_cx_captcha_confirmed_89_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.captchaConfirmed());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(90, "cx-form-errors", 31);
    i0.ɵɵelementStart(91, "button", 32);
    i0.ɵɵtext(92);
    i0.ɵɵpipe(93, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(94, "a", 33);
    i0.ɵɵpipe(95, "cxUrl");
    i0.ɵɵtext(96);
    i0.ɵɵpipe(97, "cxTranslate");
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    let tmp_12_0;
    let tmp_18_0;
    let tmp_24_0;
    let tmp_37_0;
    let tmp_43_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("formGroup", ctx_r1.registerForm);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 52, "register.titleOptional"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("clearable", false)("items", i0.ɵɵpipeBind1(13, 54, ctx_r1.titles$))("placeholder", i0.ɵɵpipeBind1(14, 56, "register.selectTitle"))("searchable", false)("cxNgSelectA11y", i0.ɵɵpureFunction0(98, _c4));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(19, 58, "register.firstName.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(22, 60, "register.firstName.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_12_0 = ctx_r1.registerForm.get("firstName")) == null ? null : tmp_12_0.touched) && ((tmp_12_0 = ctx_r1.registerForm.get("firstName")) == null ? null : tmp_12_0.invalid))("aria-errormessage", "firstNameError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(29, 62, "register.lastName.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(32, 64, "register.lastName.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_18_0 = ctx_r1.registerForm.get("lastName")) == null ? null : tmp_18_0.touched) && ((tmp_18_0 = ctx_r1.registerForm.get("lastName")) == null ? null : tmp_18_0.invalid))("aria-errormessage", "lastNameError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(39, 66, "register.emailAddress.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(42, 68, "register.emailAddress.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_24_0 = ctx_r1.registerForm.get("email")) == null ? null : tmp_24_0.touched) && ((tmp_24_0 = ctx_r1.registerForm.get("email")) == null ? null : tmp_24_0.invalid))("aria-errormessage", "emailError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(49, 70, "register.password.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(52, 72, "register.password.placeholder"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(53, 74, "register.password.placeholder"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(56, 76, "register.passwordMinRequirements"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(63, 78, "register.confirmPassword.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(66, 80, "register.confirmPassword.placeholder"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(67, 82, "register.confirmPassword.placeholder"))("aria-invalid", ((tmp_37_0 = ctx_r1.registerForm.get("passwordconf")) == null ? null : tmp_37_0.touched) && ((tmp_37_0 = ctx_r1.registerForm.get("passwordconf")) == null ? null : tmp_37_0.invalid))("aria-errormessage", "passwordconfError");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(73, 84, ctx_r1.anonymousConsent$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.additionalRegistrationConsents);
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("aria-invalid", ((tmp_43_0 = ctx_r1.registerForm.get("termsandconditions")) == null ? null : tmp_43_0.touched) && ((tmp_43_0 = ctx_r1.registerForm.get("termsandconditions")) == null ? null : tmp_43_0.invalid))("aria-errormessage", "termsandconditionsError");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(81, 86, "register.confirmThatRead"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(83, 88, i0.ɵɵpureFunction0(99, _c5)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(85, 90, "register.termsAndConditions"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("captcha"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(93, 92, "register.register"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(95, 94, i0.ɵɵpureFunction0(100, _c3)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(97, 96, "register.signIn"));
  }
}
function RegisterComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function ResetPasswordComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 2);
  }
}
function ResetPasswordComponent_form_2_cx_form_errors_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 11);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.newPassword")))("control", ctx_r2.form.get("password"));
  }
}
function ResetPasswordComponent_form_2_cx_form_errors_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 12);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r2.form.get("password"));
  }
}
function ResetPasswordComponent_form_2_cx_form_errors_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 13);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.passwordMinRequirements")))("control", ctx_r2.form.get("passwordConfirm"));
  }
}
function ResetPasswordComponent_form_2_cx_form_errors_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 12);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r2.form.get("passwordConfirm"));
  }
}
function ResetPasswordComponent_form_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 3);
    i0.ɵɵlistener("ngSubmit", function ResetPasswordComponent_form_2_Template_form_ngSubmit_0_listener() {
      const token_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onSubmit(token_r2));
    });
    i0.ɵɵelement(1, "cx-form-required-legend");
    i0.ɵɵelementStart(2, "label")(3, "span", 4);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelement(6, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "input", 5);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵtemplate(10, ResetPasswordComponent_form_2_cx_form_errors_10_Template, 2, 6, "cx-form-errors", 6)(11, ResetPasswordComponent_form_2_cx_form_errors_11_Template, 1, 1, "cx-form-errors", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "label")(13, "span", 4);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelement(16, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(17, "input", 8);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵtemplate(20, ResetPasswordComponent_form_2_cx_form_errors_20_Template, 2, 6, "cx-form-errors", 9)(21, ResetPasswordComponent_form_2_cx_form_errors_21_Template, 1, 1, "cx-form-errors", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "button", 10);
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_6_0;
    let tmp_13_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r2.form);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(5, 17, "register.newPassword"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(8, 19, "register.password.placeholder"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(9, 21, "register.password.placeholder"))("aria-invalid", ((tmp_6_0 = ctx_r2.form.get("password")) == null ? null : tmp_6_0.touched) && ((tmp_6_0 = ctx_r2.form.get("password")) == null ? null : tmp_6_0.invalid))("aria-errormessage", "passwordError");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(15, 23, "register.passwordMinRequirements"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(18, 25, "register.confirmPassword.placeholder"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(19, 27, "register.confirmPassword.placeholder"))("aria-invalid", ((tmp_13_0 = ctx_r2.form.get("passwordConfirm")) == null ? null : tmp_13_0.touched) && ((tmp_13_0 = ctx_r2.form.get("passwordConfirm")) == null ? null : tmp_13_0.invalid))("aria-errormessage", "passwordConfirmError");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.form.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 29, "register.resetPassword"), " ");
  }
}
function UpdateEmailComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 12);
  }
}
function UpdateEmailComponent_cx_form_errors_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 13);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateEmailForm.newEmailAddress.label")))("control", ctx_r0.form.get("email"));
  }
}
function UpdateEmailComponent_cx_form_errors_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.form.get("email"));
  }
}
function UpdateEmailComponent_cx_form_errors_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 15);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateEmailForm.confirmNewEmailAddress.label")))("control", ctx_r0.form.get("confirmEmail"));
  }
}
function UpdateEmailComponent_cx_form_errors_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.form.get("confirmEmail"));
  }
}
function UpdateEmailComponent_cx_form_errors_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 16);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateEmailForm.password.label")))("control", ctx_r0.form.get("password"));
  }
}
function UpdateEmailComponent_cx_form_errors_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.form.get("password"));
  }
}
function MyAccountV2EmailComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 7);
  }
}
function MyAccountV2EmailComponent_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function MyAccountV2EmailComponent_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEdit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "common.edit"), " ");
  }
}
function MyAccountV2EmailComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 1)(2, "label", 9);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 10);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, "myAccountV2Email.email"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (tmp_2_0 = i0.ɵɵpipeBind1(7, 4, ctx_r1.user$)) == null ? null : tmp_2_0.uid, " ");
  }
}
function MyAccountV2EmailComponent_cx_message_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-message", 11);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("closeMessage", function MyAccountV2EmailComponent_cx_message_11_Template_cx_message_closeMessage_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeDialogConfirmationAlert());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 2, "myAccountV2Email.reloginIndicator"))("type", ctx_r1.globalMessageType.MSG_TYPE_INFO);
  }
}
function MyAccountV2EmailComponent_div_12_cx_form_errors_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 26);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateEmailForm.newEmailAddress.label")))("control", ctx_r1.form.get("email"));
  }
}
function MyAccountV2EmailComponent_div_12_cx_form_errors_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("email"));
  }
}
function MyAccountV2EmailComponent_div_12_cx_form_errors_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 28);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateEmailForm.confirmNewEmailAddress.label")))("control", ctx_r1.form.get("confirmEmail"));
  }
}
function MyAccountV2EmailComponent_div_12_cx_form_errors_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("confirmEmail"));
  }
}
function MyAccountV2EmailComponent_div_12_cx_form_errors_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 29);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateEmailForm.password.label")))("control", ctx_r1.form.get("password"));
  }
}
function MyAccountV2EmailComponent_div_12_cx_form_errors_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("password"));
  }
}
function MyAccountV2EmailComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "form", 13);
    i0.ɵɵlistener("ngSubmit", function MyAccountV2EmailComponent_div_12_Template_form_ngSubmit_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubmit());
    });
    i0.ɵɵelementStart(2, "label")(3, "span", 9);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "input", 14);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "label")(9, "span", 9);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "input", 15);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵtemplate(14, MyAccountV2EmailComponent_div_12_cx_form_errors_14_Template, 2, 6, "cx-form-errors", 16)(15, MyAccountV2EmailComponent_div_12_cx_form_errors_15_Template, 1, 1, "cx-form-errors", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "label")(17, "span", 9);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(20, "input", 18);
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵtemplate(22, MyAccountV2EmailComponent_div_12_cx_form_errors_22_Template, 2, 6, "cx-form-errors", 19)(23, MyAccountV2EmailComponent_div_12_cx_form_errors_23_Template, 1, 1, "cx-form-errors", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "label")(25, "span", 20);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(28, "input", 21);
    i0.ɵɵpipe(29, "cxTranslate");
    i0.ɵɵpipe(30, "cxTranslate");
    i0.ɵɵtemplate(31, MyAccountV2EmailComponent_div_12_cx_form_errors_31_Template, 2, 6, "cx-form-errors", 22)(32, MyAccountV2EmailComponent_div_12_cx_form_errors_32_Template, 1, 1, "cx-form-errors", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 23)(34, "button", 24);
    i0.ɵɵlistener("click", function MyAccountV2EmailComponent_div_12_Template_button_click_34_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancelEdit());
    });
    i0.ɵɵtext(35);
    i0.ɵɵpipe(36, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "button", 25);
    i0.ɵɵlistener("click", function MyAccountV2EmailComponent_div_12_Template_button_click_37_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubmit());
    });
    i0.ɵɵtext(38);
    i0.ɵɵpipe(39, "cxTranslate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_6_0;
    let tmp_12_0;
    let tmp_19_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 25, "myAccountV2Email.emailAddress"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", (tmp_3_0 = i0.ɵɵpipeBind1(7, 27, ctx_r1.user$)) == null ? null : tmp_3_0.uid);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 29, "myAccountV2Email.newEmailAddress"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(13, 31, "myAccountV2Email.emailPlaceHolder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_6_0 = ctx_r1.form.get("email")) == null ? null : tmp_6_0.touched) && ((tmp_6_0 = ctx_r1.form.get("email")) == null ? null : tmp_6_0.invalid))("aria-errormessage", "emailError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 33, "myAccountV2Email.confirmNewEmailAddress"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(21, 35, "myAccountV2Email.emailPlaceHolder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_12_0 = ctx_r1.form.get("confirmEmail")) == null ? null : tmp_12_0.touched) && ((tmp_12_0 = ctx_r1.form.get("confirmEmail")) == null ? null : tmp_12_0.invalid))("aria-errormessage", "confirmEmailError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 37, "myAccountV2Email.password"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(29, 39, "myAccountV2Email.passwordPlaceHolder"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(30, 41, "myAccountV2Email.passwordPlaceHolder"))("aria-invalid", ((tmp_19_0 = ctx_r1.form.get("password")) == null ? null : tmp_19_0.touched) && ((tmp_19_0 = ctx_r1.form.get("password")) == null ? null : tmp_19_0.invalid))("aria-errormessage", "passwordError");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(36, 43, "common.cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.form.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(39, 45, "common.save"), " ");
  }
}
function UpdatePasswordComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 12);
  }
}
function UpdatePasswordComponent_cx_form_errors_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 13);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updatePasswordForm.oldPassword.label")))("control", ctx_r0.form.get("oldPassword"));
  }
}
function UpdatePasswordComponent_cx_form_errors_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.form.get("oldPassword"));
  }
}
function UpdatePasswordComponent_cx_form_errors_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 15);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updatePasswordForm.newPassword.label")))("control", ctx_r0.form.get("newPassword"));
  }
}
function UpdatePasswordComponent_cx_form_errors_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.form.get("newPassword"));
  }
}
function UpdatePasswordComponent_cx_form_errors_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 16);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updatePasswordForm.confirmPassword.label")))("control", ctx_r0.form.get("newPasswordConfirm"));
  }
}
function UpdatePasswordComponent_cx_form_errors_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.form.get("newPasswordConfirm"));
  }
}
function UpdatePasswordComponent_ng_container_34_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 17);
    i0.ɵɵlistener("click", function UpdatePasswordComponent_ng_container_34_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.navigateTo("home"));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "common.cancel"), " ");
  }
}
function UpdatePasswordComponent_ng_container_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 18);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction0(6, _c1)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "common.cancel"));
  }
}
function MyAccountV2PasswordComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 16);
  }
}
function MyAccountV2PasswordComponent_cx_message_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-message", 17);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("closeMessage", function MyAccountV2PasswordComponent_cx_message_6_Template_cx_message_closeMessage_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeDialogConfirmationAlert());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 2, "myAccountV2PasswordForm.reloginIndicator"))("type", ctx_r1.globalMessageType.MSG_TYPE_INFO);
  }
}
function MyAccountV2PasswordComponent_cx_form_errors_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 18);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updatePasswordForm.oldPassword.label")))("control", ctx_r1.form.get("oldPassword"));
  }
}
function MyAccountV2PasswordComponent_cx_form_errors_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("oldPassword"));
  }
}
function MyAccountV2PasswordComponent_cx_form_errors_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 20);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updatePasswordForm.newPassword.label")))("control", ctx_r1.form.get("newPassword"));
  }
}
function MyAccountV2PasswordComponent_cx_form_errors_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("newPassword"));
  }
}
function MyAccountV2PasswordComponent_cx_form_errors_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 21);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updatePasswordForm.confirmPassword.label")))("control", ctx_r1.form.get("newPasswordConfirm"));
  }
}
function MyAccountV2PasswordComponent_cx_form_errors_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("newPasswordConfirm"));
  }
}
const _c6 = a0 => ({
  ariaLabel: a0
});
function UpdateProfileComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 14);
  }
}
function UpdateProfileComponent_ng_option_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-option", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const title_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", title_r1.code);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(title_r1.name);
  }
}
function UpdateProfileComponent_cx_form_errors_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 16);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateProfileForm.firstName.label")))("control", ctx_r1.form.get("firstName"));
  }
}
function UpdateProfileComponent_cx_form_errors_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("firstName"));
  }
}
function UpdateProfileComponent_cx_form_errors_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 18);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateProfileForm.lastName.label")))("control", ctx_r1.form.get("lastName"));
  }
}
function UpdateProfileComponent_cx_form_errors_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("lastName"));
  }
}
function UpdateProfileComponent_cx_form_errors_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 19);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateProfileForm.customerId")))("control", ctx_r1.form.get("customerId"));
  }
}
function UpdateProfileComponent_cx_form_errors_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.form.get("customerId"));
  }
}
function UpdateProfileComponent_ng_container_37_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 20);
    i0.ɵɵlistener("click", function UpdateProfileComponent_ng_container_37_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navigateTo("home"));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "common.cancel"), " ");
  }
}
function UpdateProfileComponent_ng_container_38_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 21);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction0(6, _c1)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, "common.cancel"));
  }
}
function MyAccountV2ProfileComponent_cx_spinner_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner", 6);
  }
}
function MyAccountV2ProfileComponent_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function MyAccountV2ProfileComponent_button_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEdit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "common.edit"), " ");
  }
}
function MyAccountV2ProfileComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 1)(2, "label", 8);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "label", 9);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 1)(9, "label", 8);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "label", 9);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "async");
    i0.ɵɵpipe(15, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 1)(17, "label", 8);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "label", 9);
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "async");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_4_0;
    let tmp_6_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, "myAccountV2UserProfile.title"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (tmp_2_0 = i0.ɵɵpipeBind1(7, 9, ctx_r1.user$)) == null ? null : tmp_2_0.title, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 11, "myAccountV2UserProfile.name"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", (tmp_4_0 = i0.ɵɵpipeBind1(14, 13, ctx_r1.user$)) == null ? null : tmp_4_0.firstName, " ", (tmp_4_0 = i0.ɵɵpipeBind1(15, 15, ctx_r1.user$)) == null ? null : tmp_4_0.lastName, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 17, "myAccountV2UserProfile.customerId"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (tmp_6_0 = i0.ɵɵpipeBind1(22, 19, ctx_r1.user$)) == null ? null : tmp_6_0.customerId, " ");
  }
}
function MyAccountV2ProfileComponent_div_11_ng_option_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-option", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const title_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", title_r4.code);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(title_r4.name);
  }
}
function MyAccountV2ProfileComponent_div_11_cx_form_errors_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 26);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateProfileForm.firstName.label")))("control", ctx_r1.form.get("firstName"));
  }
}
function MyAccountV2ProfileComponent_div_11_cx_form_errors_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("firstName"));
  }
}
function MyAccountV2ProfileComponent_div_11_cx_form_errors_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 28);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateProfileForm.lastName.label")))("control", ctx_r1.form.get("lastName"));
  }
}
function MyAccountV2ProfileComponent_div_11_cx_form_errors_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("lastName"));
  }
}
function MyAccountV2ProfileComponent_div_11_cx_form_errors_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 29);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "updateProfileForm.customerId")))("control", ctx_r1.form.get("customerId"));
  }
}
function MyAccountV2ProfileComponent_div_11_cx_form_errors_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("customerId"));
  }
}
function MyAccountV2ProfileComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "form", 11);
    i0.ɵɵlistener("ngSubmit", function MyAccountV2ProfileComponent_div_11_Template_form_ngSubmit_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubmit());
    });
    i0.ɵɵelementStart(2, "label")(3, "span", 12);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ng-select", 13);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵtemplate(8, MyAccountV2ProfileComponent_div_11_ng_option_8_Template, 2, 2, "ng-option", 14);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "label")(11, "span", 12);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "input", 15);
    i0.ɵɵtemplate(15, MyAccountV2ProfileComponent_div_11_cx_form_errors_15_Template, 2, 6, "cx-form-errors", 16)(16, MyAccountV2ProfileComponent_div_11_cx_form_errors_16_Template, 1, 1, "cx-form-errors", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "label")(18, "span", 12);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(21, "input", 18);
    i0.ɵɵtemplate(22, MyAccountV2ProfileComponent_div_11_cx_form_errors_22_Template, 2, 6, "cx-form-errors", 19)(23, MyAccountV2ProfileComponent_div_11_cx_form_errors_23_Template, 1, 1, "cx-form-errors", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "label")(25, "span", 12);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(28, "input", 20);
    i0.ɵɵtemplate(29, MyAccountV2ProfileComponent_div_11_cx_form_errors_29_Template, 2, 6, "cx-form-errors", 21)(30, MyAccountV2ProfileComponent_div_11_cx_form_errors_30_Template, 1, 1, "cx-form-errors", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(31, "div", 22)(32, "button", 23);
    i0.ɵɵlistener("click", function MyAccountV2ProfileComponent_div_11_Template_button_click_32_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancelEdit());
    });
    i0.ɵɵtext(33);
    i0.ɵɵpipe(34, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "button", 24);
    i0.ɵɵlistener("click", function MyAccountV2ProfileComponent_div_11_Template_button_click_35_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubmit());
    });
    i0.ɵɵtext(36);
    i0.ɵɵpipe(37, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_8_0;
    let tmp_13_0;
    let tmp_18_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 24, "myAccountV2UserProfile.title"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("clearable", false)("searchable", false)("cxNgSelectA11y", i0.ɵɵpureFunction1(40, _c6, i0.ɵɵpipeBind1(7, 26, "myAccountV2UserProfile.title")));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(9, 28, ctx_r1.titles$));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 30, "myAccountV2UserProfile.firstName"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-invalid", ((tmp_8_0 = ctx_r1.form.get("firstName")) == null ? null : tmp_8_0.touched) && ((tmp_8_0 = ctx_r1.form.get("firstName")) == null ? null : tmp_8_0.invalid))("aria-errormessage", "firstNameError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 32, "myAccountV2UserProfile.lastName"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-invalid", ((tmp_13_0 = ctx_r1.form.get("lastName")) == null ? null : tmp_13_0.touched) && ((tmp_13_0 = ctx_r1.form.get("lastName")) == null ? null : tmp_13_0.invalid))("aria-errormessage", "lastNameError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 34, "myAccountV2UserProfile.customerId"));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-invalid", ((tmp_18_0 = ctx_r1.form.get("customerId")) == null ? null : tmp_18_0.touched) && ((tmp_18_0 = ctx_r1.form.get("customerId")) == null ? null : tmp_18_0.invalid))("aria-errormessage", "customerIdError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(34, 36, "common.cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.form.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(37, 38, "common.save"), " ");
  }
}
const _c7 = ["submit"];
const _c8 = () => ({
  required: "true"
});
function AddressFormComponent_ng_container_3_div_1_cx_form_errors_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 32);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.country")))("control", ctx_r2.addressForm.get("country.isocode"));
  }
}
function AddressFormComponent_ng_container_3_div_1_cx_form_errors_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 33);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("country.isocode"));
  }
}
function AddressFormComponent_ng_container_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label")(2, "span", 6);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelement(5, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ng-select", 30);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("change", function AddressFormComponent_ng_container_3_div_1_Template_ng_select_change_6_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.countrySelected($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, AddressFormComponent_ng_container_3_div_1_cx_form_errors_8_Template, 2, 6, "cx-form-errors", 31)(9, AddressFormComponent_ng_container_3_div_1_cx_form_errors_9_Template, 1, 1, "cx-form-errors", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const countries_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 9, "addressForm.country"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 11, "addressForm.selectOne"));
    i0.ɵɵproperty("inputAttrs", i0.ɵɵpureFunction0(13, _c8))("searchable", true)("clearable", false)("items", countries_r4)("cxNgSelectA11y", i0.ɵɵpureFunction0(14, _c4));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
  }
}
function AddressFormComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddressFormComponent_ng_container_3_div_1_Template, 10, 15, "div", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const countries_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", countries_r4.length !== 0);
  }
}
function AddressFormComponent_div_5_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label")(2, "span", 6);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "ng-select", 34);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const titles_r5 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, "addressForm.titleOptional"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("searchable", true)("clearable", false)("items", titles_r5)("placeholder", i0.ɵɵpipeBind1(6, 8, "addressForm.title"))("cxNgSelectA11y", i0.ɵɵpureFunction1(12, _c6, i0.ɵɵpipeBind1(7, 10, "addressForm.title")));
  }
}
function AddressFormComponent_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddressFormComponent_div_5_ng_container_1_div_1_Template, 8, 14, "div", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const titles_r5 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", titles_r5.length !== 0);
  }
}
function AddressFormComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, AddressFormComponent_div_5_ng_container_1_Template, 2, 1, "ng-container", 3);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r2.titles$));
  }
}
function AddressFormComponent_cx_form_errors_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 35);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.firstName.label")))("control", ctx_r2.addressForm.get("firstName"));
  }
}
function AddressFormComponent_cx_form_errors_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 33);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("firstName"));
  }
}
function AddressFormComponent_cx_form_errors_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 36);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.lastName.label")))("control", ctx_r2.addressForm.get("lastName"));
  }
}
function AddressFormComponent_cx_form_errors_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 33);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("lastName"));
  }
}
function AddressFormComponent_cx_form_errors_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.address1")))("control", ctx_r2.addressForm.get("line1"));
  }
}
function AddressFormComponent_cx_form_errors_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 33);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("line1"));
  }
}
function AddressFormComponent_cx_form_errors_52_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 38);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.city.label")))("control", ctx_r2.addressForm.get("town"));
  }
}
function AddressFormComponent_cx_form_errors_53_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 33);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("town"));
  }
}
function AddressFormComponent_cx_form_errors_62_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 39);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.zipCode.label")))("control", ctx_r2.addressForm.get("postalCode"));
  }
}
function AddressFormComponent_cx_form_errors_63_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 33);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("postalCode"));
  }
}
function AddressFormComponent_ng_container_64_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 23)(2, "label")(3, "span", 6);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelement(6, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "ng-select", 41);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelement(10, "cx-form-errors", 33);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const regions_r6 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(5, 10, "addressForm.state"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("bindLabel", regions_r6[0].name ? "name" : "isocode");
    i0.ɵɵpropertyInterpolate("bindValue", regions_r6[0].name ? "isocode" : "region");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(8, 12, "addressForm.selectOne"));
    i0.ɵɵproperty("inputAttrs", i0.ɵɵpureFunction0(16, _c8))("searchable", true)("clearable", false)("items", regions_r6)("cxNgSelectA11y", i0.ɵɵpureFunction1(17, _c6, i0.ɵɵpipeBind1(9, 14, "addressForm.state")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("control", ctx_r2.addressForm.get("region.isocode"));
  }
}
function AddressFormComponent_ng_container_64_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 40);
    i0.ɵɵtemplate(1, AddressFormComponent_ng_container_64_ng_container_1_Template, 11, 19, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const regions_r6 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", regions_r6.length !== 0);
  }
}
function AddressFormComponent_div_81_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 42)(2, "label")(3, "input", 43);
    i0.ɵɵlistener("change", function AddressFormComponent_div_81_Template_input_change_3_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleDefaultAddress());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 44);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 1, "addressForm.setAsDefault"));
  }
}
function AddressFormComponent_div_85_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28)(1, "button", 45);
    i0.ɵɵlistener("click", function AddressFormComponent_div_85_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.back());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.cancelBtnLabel || i0.ɵɵpipeBind1(3, 1, "addressForm.chooseAddress"), " ");
  }
}
function AddressBookComponent_ng_container_1_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function AddressBookComponent_ng_container_1_div_6_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "cx-card", 12);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("editCard", function AddressBookComponent_ng_container_1_div_6_div_2_Template_cx_card_editCard_1_listener() {
      const address_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.editAddressButtonHandle(address_r4));
    })("setDefaultCard", function AddressBookComponent_ng_container_1_div_6_div_2_Template_cx_card_setDefaultCard_1_listener() {
      const address_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setAddressAsDefault(address_r4));
    })("deleteCard", function AddressBookComponent_ng_container_1_div_6_div_2_Template_cx_card_deleteCard_1_listener() {
      let tmp_7_0;
      const address_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setEdit((tmp_7_0 = address_r4.id) !== null && tmp_7_0 !== undefined ? tmp_7_0 : ""));
    })("cancelCard", function AddressBookComponent_ng_container_1_div_6_div_2_Template_cx_card_cancelCard_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.cancelCard());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const address_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("index", i_r5)("border", true)("fitToContainer", true)("content", i0.ɵɵpipeBind1(2, 5, ctx_r1.getCardContent(address_r4)))("editMode", address_r4.id === ctx_r1.editCard);
  }
}
function AddressBookComponent_ng_container_1_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, AddressBookComponent_ng_container_1_div_6_div_1_Template, 2, 3, "div", 8)(2, AddressBookComponent_ng_container_1_div_6_div_2_Template, 3, 7, "div", 9);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 2, ctx_r1.addresses$));
  }
}
function AddressBookComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4)(3, "button", 5);
    i0.ɵɵlistener("click", function AddressBookComponent_ng_container_1_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addAddressButtonHandle());
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(6, AddressBookComponent_ng_container_1_div_6_Template, 4, 4, "div", 6);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const loading_r6 = i0.ɵɵreference(7);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 3, "addressBook.addNewAddress"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(7, 5, ctx_r1.addressesStateLoading$))("ngIfElse", loading_r6);
  }
}
function AddressBookComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "section")(2, "h2", 13);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "cx-address-form", 14);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵlistener("submitAddress", function AddressBookComponent_ng_container_3_Template_cx_address_form_submitAddress_5_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addAddressSubmit($event));
    })("backToAddress", function AddressBookComponent_ng_container_3_Template_cx_address_form_backToAddress_5_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addAddressCancel());
    })("cancelCard", function AddressBookComponent_ng_container_3_Template_cx_address_form_cancelCard_5_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.cancelCard());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_6_0;
    let tmp_7_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 6, "addressBook.addNewDeliveryAddress"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("actionBtnLabel", i0.ɵɵpipeBind1(6, 8, "addressBook.addAddress"));
    i0.ɵɵpropertyInterpolate("cancelBtnLabel", i0.ɵɵpipeBind1(7, 10, "addressBook.backToAddressList"));
    i0.ɵɵproperty("showTitleCode", true)("showCancelBtn", !(((tmp_6_0 = i0.ɵɵpipeBind1(8, 12, ctx_r1.addresses$)) == null ? null : tmp_6_0.length) === 0))("setAsDefaultField", !(((tmp_7_0 = i0.ɵɵpipeBind1(9, 14, ctx_r1.addresses$)) == null ? null : tmp_7_0.length) === 0));
  }
}
function AddressBookComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "section")(2, "h2", 13);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "cx-address-form", 15);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("submitAddress", function AddressBookComponent_ng_container_5_Template_cx_address_form_submitAddress_5_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.editAddressSubmit($event));
    })("backToAddress", function AddressBookComponent_ng_container_5_Template_cx_address_form_backToAddress_5_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.editAddressCancel());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, "addressBook.editDeliveryAddress"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("actionBtnLabel", i0.ɵɵpipeBind1(6, 7, "addressBook.updateAddress"));
    i0.ɵɵpropertyInterpolate("cancelBtnLabel", i0.ɵɵpipeBind1(7, 9, "addressBook.backToAddressList"));
    i0.ɵɵproperty("showTitleCode", true)("addressData", ctx_r1.currentAddress);
  }
}
function AddressBookComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function SuggestedAddressDialogComponent_div_1_h3_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "addressSuggestion.verifyYourAddress"), " ");
  }
}
function SuggestedAddressDialogComponent_div_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "addressSuggestion.verifyYourAddress"), " ");
  }
}
function SuggestedAddressDialogComponent_div_1_div_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "input", 24);
    i0.ɵɵtwoWayListener("ngModelChange", function SuggestedAddressDialogComponent_div_1_div_16_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedAddress, $event) || (ctx_r1.selectedAddress = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 25);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 26)(6, "div", 16)(7, "div", 17);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 17);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 17);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 17)(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 17);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 17);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 17);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const suggestedAddress_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const data_r6 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedAddress);
    i0.ɵɵproperty("value", suggestedAddress_r4)("id", "suggested-addresses--suggested-" + i_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", "suggested-addresses--suggested-" + i_r5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(4, 13, "addressSuggestion.suggestedAddress"), " ", data_r6.suggestedAddresses.length > 1 ? i_r5 + 1 : null, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(suggestedAddress_r4 == null ? null : suggestedAddress_r4.firstName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(suggestedAddress_r4 == null ? null : suggestedAddress_r4.lastName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(suggestedAddress_r4 == null ? null : suggestedAddress_r4.line1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(suggestedAddress_r4 == null ? null : suggestedAddress_r4.line2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(suggestedAddress_r4 == null ? null : suggestedAddress_r4.town);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", suggestedAddress_r4 == null ? null : suggestedAddress_r4.region == null ? null : suggestedAddress_r4.region.isocode, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", suggestedAddress_r4 == null ? null : suggestedAddress_r4.postalCode, " ");
  }
}
function SuggestedAddressDialogComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtemplate(2, SuggestedAddressDialogComponent_div_1_h3_2_Template, 3, 3, "h3", 4)(3, SuggestedAddressDialogComponent_div_1_div_3_Template, 3, 3, "div", 4);
    i0.ɵɵelementStart(4, "button", 5);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵlistener("click", function SuggestedAddressDialogComponent_div_1_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeModal("Cross click"));
    });
    i0.ɵɵelementStart(7, "span", 6);
    i0.ɵɵelement(8, "cx-icon", 7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div", 8)(10, "div", 9)(11, "p");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 10);
    i0.ɵɵtemplate(16, SuggestedAddressDialogComponent_div_1_div_16_Template, 22, 15, "div", 11);
    i0.ɵɵelementStart(17, "div", 12)(18, "input", 13);
    i0.ɵɵtwoWayListener("ngModelChange", function SuggestedAddressDialogComponent_div_1_Template_input_ngModelChange_18_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedAddress, $event) || (ctx_r1.selectedAddress = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "label", 14);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 15)(23, "div", 16)(24, "div", 17);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 17);
    i0.ɵɵtext(27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 17)(29, "span");
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(31, "div", 17);
    i0.ɵɵtext(32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 17);
    i0.ɵɵtext(34);
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementStart(35, "div", 18)(36, "div", 19)(37, "div", 20)(38, "button", 21);
    i0.ɵɵlistener("click", function SuggestedAddressDialogComponent_div_1_Template_button_click_38_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeModal("Edit address"));
    });
    i0.ɵɵtext(39);
    i0.ɵɵpipe(40, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "button", 22);
    i0.ɵɵlistener("click", function SuggestedAddressDialogComponent_div_1_Template_button_click_41_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeModal(ctx_r1.selectedAddress));
    });
    i0.ɵɵtext(42);
    i0.ɵɵpipe(43, "cxTranslate");
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const data_r6 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "a11yDialogsHeading");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yDialogsHeading");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(5, 20, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 22, "common.close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(13, 24, "addressSuggestion.ensureAccuracySuggestChange"), " ", i0.ɵɵpipeBind1(14, 26, "addressSuggestion.chooseAddressToUse"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", data_r6.suggestedAddresses);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedAddress);
    i0.ɵɵproperty("value", data_r6.enteredAddress);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 28, "addressSuggestion.enteredAddress"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate2(" ", data_r6.enteredAddress == null ? null : data_r6.enteredAddress.firstName, " ", data_r6.enteredAddress == null ? null : data_r6.enteredAddress.lastName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(data_r6.enteredAddress == null ? null : data_r6.enteredAddress.line1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(data_r6.enteredAddress == null ? null : data_r6.enteredAddress.line2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", data_r6.enteredAddress == null ? null : data_r6.enteredAddress.town, " ", data_r6.enteredAddress == null ? null : data_r6.enteredAddress.region == null ? null : data_r6.enteredAddress.region.isocode, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", data_r6.enteredAddress == null ? null : data_r6.enteredAddress.postalCode, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(40, 30, "addressSuggestion.editAddress"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(43, 32, "addressSuggestion.saveAddress"), " ");
  }
}
function OneTimePasswordRegisterComponent_section_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.firstName.label")))("control", ctx_r1.registerForm.get("firstName"));
  }
}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 23);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("firstName"));
  }
}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.lastName.label")))("control", ctx_r1.registerForm.get("lastName"));
  }
}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 23);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("lastName"));
  }
}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_42_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.emailAddress.label")))("control", ctx_r1.registerForm.get("email"));
  }
}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_43_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 23);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("email"));
  }
}
function OneTimePasswordRegisterComponent_section_0_label_46_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵelement(1, "input", 28);
    i0.ɵɵelementStart(2, "span", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const anonymousConsent_r3 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r1.isConsentGiven(anonymousConsent_r3.consent));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", anonymousConsent_r3.template, " ");
  }
}
function OneTimePasswordRegisterComponent_section_0_div_48_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label")(2, "input", 31);
    i0.ɵɵlistener("change", function OneTimePasswordRegisterComponent_section_0_div_48_div_1_div_1_Template_input_change_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const i_r5 = i0.ɵɵnextContext().index;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.updateAdditionalConsents($event, i_r5));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 20);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "cx-form-errors", 23);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const id_r6 = ctx.ngIf;
    const ctx_r6 = i0.ɵɵnextContext();
    const control_r8 = ctx_r6.$implicit;
    const i_r5 = ctx_r6.index;
    const consents_r9 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("required", consents_r9[i_r5].required)("name", id_r6)("formControlName", i_r5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", consents_r9[i_r5].template.description, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("control", control_r8);
  }
}
function OneTimePasswordRegisterComponent_section_0_div_48_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, OneTimePasswordRegisterComponent_section_0_div_48_div_1_div_1_Template, 6, 5, "div", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r5 = ctx.index;
    const consents_r9 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", consents_r9[i_r5] == null ? null : consents_r9[i_r5].template == null ? null : consents_r9[i_r5].template.id);
  }
}
function OneTimePasswordRegisterComponent_section_0_div_48_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, OneTimePasswordRegisterComponent_section_0_div_48_div_1_Template, 2, 1, "div", 30);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.additionalConsents.controls);
  }
}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_61_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.termsAndConditions")))("control", ctx_r1.registerForm.get("termsandconditions"));
  }
}
function OneTimePasswordRegisterComponent_section_0_cx_form_errors_62_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 23);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("termsandconditions"));
  }
}
function OneTimePasswordRegisterComponent_section_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 2);
    i0.ɵɵtemplate(1, OneTimePasswordRegisterComponent_section_0_div_1_Template, 2, 3, "div", 3);
    i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "div", 6)(5, "form", 7);
    i0.ɵɵlistener("ngSubmit", function OneTimePasswordRegisterComponent_section_0_Template_form_ngSubmit_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.submitForm());
    });
    i0.ɵɵelementStart(6, "div", 8)(7, "label")(8, "span", 9);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "ng-select", 10);
    i0.ɵɵpipe(12, "async");
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 8)(15, "label")(16, "span", 9);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵelement(19, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(20, "input", 11);
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵtemplate(22, OneTimePasswordRegisterComponent_section_0_cx_form_errors_22_Template, 2, 6, "cx-form-errors", 12)(23, OneTimePasswordRegisterComponent_section_0_cx_form_errors_23_Template, 1, 1, "cx-form-errors", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "div", 8)(25, "label")(26, "span", 9);
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "cxTranslate");
    i0.ɵɵelement(29, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(30, "input", 14);
    i0.ɵɵpipe(31, "cxTranslate");
    i0.ɵɵtemplate(32, OneTimePasswordRegisterComponent_section_0_cx_form_errors_32_Template, 2, 6, "cx-form-errors", 12)(33, OneTimePasswordRegisterComponent_section_0_cx_form_errors_33_Template, 1, 1, "cx-form-errors", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(34, "div", 8)(35, "label")(36, "span", 9);
    i0.ɵɵtext(37);
    i0.ɵɵpipe(38, "cxTranslate");
    i0.ɵɵelement(39, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(40, "input", 15);
    i0.ɵɵpipe(41, "cxTranslate");
    i0.ɵɵtemplate(42, OneTimePasswordRegisterComponent_section_0_cx_form_errors_42_Template, 2, 6, "cx-form-errors", 12)(43, OneTimePasswordRegisterComponent_section_0_cx_form_errors_43_Template, 1, 1, "cx-form-errors", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(44, "div", 8)(45, "div", 16);
    i0.ɵɵtemplate(46, OneTimePasswordRegisterComponent_section_0_label_46_Template, 4, 2, "label", 17);
    i0.ɵɵpipe(47, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(48, OneTimePasswordRegisterComponent_section_0_div_48_Template, 2, 1, "div", 18);
    i0.ɵɵelementStart(49, "div", 8)(50, "div", 16)(51, "label");
    i0.ɵɵelement(52, "input", 19);
    i0.ɵɵelementStart(53, "span", 20);
    i0.ɵɵtext(54);
    i0.ɵɵpipe(55, "cxTranslate");
    i0.ɵɵelementStart(56, "a", 21);
    i0.ɵɵpipe(57, "cxUrl");
    i0.ɵɵtext(58);
    i0.ɵɵpipe(59, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(60, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(61, OneTimePasswordRegisterComponent_section_0_cx_form_errors_61_Template, 2, 6, "cx-form-errors", 12)(62, OneTimePasswordRegisterComponent_section_0_cx_form_errors_62_Template, 1, 1, "cx-form-errors", 13);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(63, "cx-captcha", 22);
    i0.ɵɵlistener("confirmed", function OneTimePasswordRegisterComponent_section_0_Template_cx_captcha_confirmed_63_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.captchaConfirmed());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(64, "cx-form-errors", 23);
    i0.ɵɵelementStart(65, "button", 24);
    i0.ɵɵtext(66);
    i0.ɵɵpipe(67, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(68, "a", 25);
    i0.ɵɵpipe(69, "cxUrl");
    i0.ɵɵtext(70);
    i0.ɵɵpipe(71, "cxTranslate");
    i0.ɵɵelementEnd()()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("formGroup", ctx_r1.registerForm);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 31, "register.title"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("clearable", false)("items", i0.ɵɵpipeBind1(12, 33, ctx_r1.titles$))("placeholder", i0.ɵɵpipeBind1(13, 35, "register.selectTitle"))("searchable", false)("cxNgSelectA11y", i0.ɵɵpureFunction0(63, _c4));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(18, 37, "register.firstName.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(21, 39, "register.firstName.placeholder"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(28, 41, "register.lastName.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(31, 43, "register.lastName.placeholder"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(38, 45, "register.emailAddress.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(41, 47, "register.emailAddress.placeholder"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(47, 49, ctx_r1.anonymousConsent$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.additionalRegistrationConsents);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(55, 51, "register.confirmThatRead"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(57, 53, i0.ɵɵpureFunction0(64, _c5)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(59, 55, "register.termsAndConditions"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("captcha"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(67, 57, "register.furtherRegistration"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(69, 59, i0.ɵɵpureFunction0(65, _c3)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(71, 61, "register.signIn"));
  }
}
function OneTimePasswordRegisterComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
const _c9 = ["noReceiveCodeLink"];
const _c10 = ["resendLink"];
const _c11 = () => ({
  cxRoute: "register"
});
const _c12 = a0 => ({
  seconds: a0
});
const _c13 = a0 => ({
  "disabled-link": a0
});
const _c14 = a0 => ({
  waitTime: a0
});
function RegistrationVerificationTokenFormComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "register.rateLimitForRegistrationMessage", i0.ɵɵpureFunction1(4, _c12, ctx_r1.waitTimeForRateLimit)), " ");
  }
}
function RegistrationVerificationTokenFormComponent_div_12_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "verificationTokenForm.sendRateLime", i0.ɵɵpureFunction1(4, _c14, ctx_r1.waitTime)), " ");
  }
}
function RegistrationVerificationTokenFormComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21)(2, "span", 22)(3, "a", 23, 1);
    i0.ɵɵlistener("keydown.enter", function RegistrationVerificationTokenFormComponent_div_12_Template_a_keydown_enter_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resendOTP());
    })("keydown.space", function RegistrationVerificationTokenFormComponent_div_12_Template_a_keydown_space_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resendOTP());
    })("click", function RegistrationVerificationTokenFormComponent_div_12_Template_a_click_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resendOTP());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, RegistrationVerificationTokenFormComponent_div_12_ng_container_7_Template, 3, 6, "ng-container", 24);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 25)(9, "a", 26, 2);
    i0.ɵɵlistener("keydown", function RegistrationVerificationTokenFormComponent_div_12_Template_a_keydown_9_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOpenInfoDailogKeyDown($event));
    })("click", function RegistrationVerificationTokenFormComponent_div_12_Template_a_click_9_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openInfoDailog());
    });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c13, ctx_r1.isResendDisabled));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "verificationTokenForm.resend"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isResendDisabled);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 6, "verificationTokenForm.noReceiveCode"), " ");
  }
}
function RegistrationVerificationTokenFormComponent_cx_form_errors_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.password.label")))("control", ctx_r1.registerForm.get("password"));
  }
}
function RegistrationVerificationTokenFormComponent_cx_form_errors_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("password"));
  }
}
function RegistrationVerificationTokenFormComponent_cx_form_errors_38_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 27);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "register.confirmPassword.label")))("control", ctx_r1.registerForm.get("passwordconf"));
  }
}
function RegistrationVerificationTokenFormComponent_cx_form_errors_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r1.registerForm.get("passwordconf"));
  }
}
function RegistrationVerificationTokenFormComponent_ng_template_48_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
let CloseAccountModalComponent = /*#__PURE__*/(() => {
  class CloseAccountModalComponent {
    handleClick(event) {
      if (event.target.tagName === this.el.nativeElement.tagName) {
        this.dismissModal('Cross click');
      }
    }
    constructor(authService, globalMessageService, routingService, translationService, userProfile, launchDialogService, el) {
      this.authService = authService;
      this.globalMessageService = globalMessageService;
      this.routingService = routingService;
      this.translationService = translationService;
      this.userProfile = userProfile;
      this.launchDialogService = launchDialogService;
      this.el = el;
      this.iconTypes = ICON_TYPE;
      this.focusConfig = {
        trap: true,
        block: true,
        autofocus: 'button',
        focusOnEscape: true
      };
      this.loading$ = new BehaviorSubject(false);
    }
    get isLoading$() {
      return this.loading$.asObservable();
    }
    ngOnInit() {
      this.isLoggedIn$ = this.authService.isUserLoggedIn();
    }
    onSuccess() {
      this.dismissModal('Success');
      this.translationService.translate('closeAccount.accountClosedSuccessfully').pipe(first()).subscribe(text => {
        this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      });
      this.authService.coreLogout().then(() => {
        this.routingService.go({
          cxRoute: 'home'
        });
      });
    }
    onError() {
      this.dismissModal('Error');
      this.translationService.translate('closeAccount.accountClosedFailure').pipe(first()).subscribe(text => {
        this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_ERROR);
      });
    }
    dismissModal(reason) {
      this.launchDialogService.closeDialog(reason);
    }
    closeAccount() {
      this.loading$.next(true);
      this.userProfile.close().subscribe({
        next: () => {
          this.onSuccess();
          this.loading$.next(false);
        },
        error: () => {
          this.onError();
          this.loading$.next(false);
        }
      });
    }
    static {
      this.ɵfac = function CloseAccountModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CloseAccountModalComponent)(i0.ɵɵdirectiveInject(i2.AuthService), i0.ɵɵdirectiveInject(i2.GlobalMessageService), i0.ɵɵdirectiveInject(i2.RoutingService), i0.ɵɵdirectiveInject(i2.TranslationService), i0.ɵɵdirectiveInject(i1.UserProfileFacade), i0.ɵɵdirectiveInject(i4.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CloseAccountModalComponent,
        selectors: [["cx-close-account-modal"]],
        hostBindings: function CloseAccountModalComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function CloseAccountModalComponent_click_HostBindingHandler($event) {
              return ctx.handleClick($event);
            });
          }
        },
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [["loaded", ""], [4, "ngIf"], [1, "modal-dialog", "modal-dialog-centered", "cx-close-account-modal", 3, "esc", "cxFocus"], [1, "modal-content", "cx-close-account-modal-container"], [1, "cx-close-account-modal-header", "cx-modal-header"], [1, "cx-close-account-modal-title"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], [4, "ngIf", "ngIfElse"], [1, "cx-spinner"], [1, "modal-body"], [1, "cx-confirmation"], [1, "cx-close-account-modal-footer", "cx-modal-footer"], [1, "btn", "btn-primary", 3, "click"], [1, "btn", "btn-block", "btn-secondary", 3, "click"]],
        template: function CloseAccountModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CloseAccountModalComponent_ng_container_0_Template, 16, 15, "ng-container", 1);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.isLoggedIn$));
          }
        },
        dependencies: [i2$1.NgIf, i4.IconComponent, i4.SpinnerComponent, i4.FocusDirective, i2$1.AsyncPipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CloseAccountModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultCloseDialogModalLayoutConfig = {
  launch: {
    CLOSE_ACCOUNT: {
      inline: true,
      component: CloseAccountModalComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CloseAccountComponent = /*#__PURE__*/(() => {
  class CloseAccountComponent {
    constructor(launchDialogService, vcr) {
      this.launchDialogService = launchDialogService;
      this.vcr = vcr;
      this.routingService = inject(RoutingService, {
        optional: true
      });
    }
    openModal() {
      const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.CLOSE_ACCOUNT, this.element, this.vcr);
      dialog?.pipe(take(1)).subscribe();
    }
    navigateTo(cxRoute) {
      this.routingService?.go({
        cxRoute
      });
    }
    static {
      this.ɵfac = function CloseAccountComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CloseAccountComponent)(i0.ɵɵdirectiveInject(i4.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CloseAccountComponent,
        selectors: [["cx-close-account"]],
        viewQuery: function CloseAccountComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
          }
        },
        standalone: false,
        decls: 10,
        vars: 5,
        consts: [["element", ""], [1, "col-lg-8", "col-md-9"], [1, "row", "cx-btn-group"], [1, "col-sm-6"], [4, "cxFeature"], [1, "btn", "btn-block", "btn-primary", 3, "click"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"]],
        template: function CloseAccountComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
            i0.ɵɵtemplate(3, CloseAccountComponent_ng_container_3_Template, 4, 3, "ng-container", 4)(4, CloseAccountComponent_ng_container_4_Template, 5, 7, "ng-container", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 3)(6, "button", 5, 0);
            i0.ɵɵlistener("click", function CloseAccountComponent_Template_button_click_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.openModal());
            });
            i0.ɵɵtext(8);
            i0.ɵɵpipe(9, "cxTranslate");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cxFeature", "a11yUseButtonsForBtnLinks");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!a11yUseButtonsForBtnLinks");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 3, "closeAccount.closeMyAccount"), " ");
          }
        },
        dependencies: [i5.RouterLink, i2.FeatureDirective, i4.BtnLikeLinkDirective, i2.UrlPipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CloseAccountComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CloseAccountModule = /*#__PURE__*/(() => {
  class CloseAccountModule {
    static {
      this.ɵfac = function CloseAccountModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CloseAccountModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CloseAccountModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CloseAccountComponent: {
              component: CloseAccountComponent,
              guards: [AuthGuard]
            }
          }
        }), provideDefaultConfig(defaultCloseDialogModalLayoutConfig)],
        imports: [CommonModule, RouterModule, UrlModule, I18nModule, IconModule, SpinnerModule, KeyboardFocusModule, FeaturesConfigModule, BtnLikeLinkModule]
      });
    }
  }
  return CloseAccountModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ForgotPasswordComponentService = /*#__PURE__*/(() => {
  class ForgotPasswordComponentService {
    constructor(userPasswordService, routingService, authConfigService, globalMessage) {
      this.userPasswordService = userPasswordService;
      this.routingService = routingService;
      this.authConfigService = authConfigService;
      this.globalMessage = globalMessage;
      this.busy$ = new BehaviorSubject(false);
      this.isUpdating$ = this.busy$.pipe(tap(state => state === true ? this.form.disable() : this.form.enable()));
      this.form = new UntypedFormGroup({
        userEmail: new UntypedFormControl('', [Validators.required, CustomFormValidators.emailValidator])
      });
    }
    /**
     * Sends an email to the user to reset the password.
     *
     * When the `ResourceOwnerPasswordFlow` is used, the user is routed
     * to the login page.
     */
    requestEmail() {
      if (!this.form.valid) {
        this.form.markAllAsTouched();
        return;
      }
      this.busy$.next(true);
      this.userPasswordService.requestForgotPasswordEmail(this.form.value.userEmail).subscribe({
        next: () => this.onSuccess(),
        error: error => this.onError(error)
      });
    }
    onSuccess() {
      this.globalMessage.add({
        key: 'forgottenPassword.passwordResetEmailSent'
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      this.busy$.next(false);
      this.form.reset();
      this.redirect();
    }
    onError(_error) {
      this.busy$.next(false);
    }
    /**
     * Redirects the user back to the login page.
     *
     * This only happens in case of the `ResourceOwnerPasswordFlow` OAuth flow.
     */
    redirect() {
      if (this.authConfigService.getOAuthFlow() === OAuthFlow.ResourceOwnerPasswordFlow) {
        this.routingService.go({
          cxRoute: 'login'
        });
      }
    }
    static {
      this.ɵfac = function ForgotPasswordComponentService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ForgotPasswordComponentService)(i0.ɵɵinject(i1.UserPasswordFacade), i0.ɵɵinject(i2.RoutingService), i0.ɵɵinject(i2.AuthConfigService), i0.ɵɵinject(i2.GlobalMessageService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ForgotPasswordComponentService,
        factory: ForgotPasswordComponentService.ɵfac
      });
    }
  }
  return ForgotPasswordComponentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ForgotPasswordComponent = /*#__PURE__*/(() => {
  class ForgotPasswordComponent {
    constructor(service) {
      this.service = service;
      this.routingService = inject(RoutingService, {
        optional: true
      });
      this.form = this.service.form;
      this.isUpdating$ = this.service.isUpdating$;
    }
    onSubmit() {
      this.service.requestEmail();
    }
    navigateTo(cxRoute) {
      this.routingService?.go({
        cxRoute
      });
    }
    static {
      this.ɵfac = function ForgotPasswordComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ForgotPasswordComponent)(i0.ɵɵdirectiveInject(ForgotPasswordComponentService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ForgotPasswordComponent,
        selectors: [["cx-forgot-password"]],
        standalone: false,
        decls: 18,
        vars: 20,
        consts: [["class", "overlay", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [1, "label-content"], ["required", "true", "type", "email", "formControlName", "userEmail", 1, "form-control", 3, "placeholder"], ["id", "userEmailError", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], [4, "cxFeature"], [1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "overlay"], ["id", "userEmailError", 3, "translationParams", "control"], [3, "control"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"]],
        template: function ForgotPasswordComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ForgotPasswordComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelement(2, "cx-form-required-legend");
            i0.ɵɵelementStart(3, "form", 1);
            i0.ɵɵlistener("ngSubmit", function ForgotPasswordComponent_Template_form_ngSubmit_3_listener() {
              return ctx.onSubmit();
            });
            i0.ɵɵelementStart(4, "label")(5, "span", 2);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "cxTranslate");
            i0.ɵɵelement(8, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "input", 3);
            i0.ɵɵpipe(10, "cxTranslate");
            i0.ɵɵtemplate(11, ForgotPasswordComponent_cx_form_errors_11_Template, 2, 6, "cx-form-errors", 4)(12, ForgotPasswordComponent_cx_form_errors_12_Template, 1, 1, "cx-form-errors", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, ForgotPasswordComponent_ng_container_13_Template, 4, 3, "ng-container", 6)(14, ForgotPasswordComponent_ng_container_14_Template, 5, 7, "ng-container", 6);
            i0.ɵɵelementStart(15, "button", 7);
            i0.ɵɵtext(16);
            i0.ɵɵpipe(17, "cxTranslate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_4_0;
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 12, ctx.isUpdating$));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 14, "forgottenPassword.emailAddress.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 16, "forgottenPassword.emailAddress.placeholder"));
            i0.ɵɵattribute("aria-invalid", ((tmp_4_0 = ctx.form.get("userEmail")) == null ? null : tmp_4_0.touched) && ((tmp_4_0 = ctx.form.get("userEmail")) == null ? null : tmp_4_0.invalid))("aria-errormessage", "userEmailError");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "a11yUseButtonsForBtnLinks");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!a11yUseButtonsForBtnLinks");
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.form.disabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 18, "common.submit"), " ");
          }
        },
        dependencies: [i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i5.RouterLink, i4.FormErrorsComponent, i4.SpinnerComponent, i2.FeatureDirective, i4.BtnLikeLinkDirective, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i2$1.AsyncPipe, i2.UrlPipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return ForgotPasswordComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ForgotPasswordModule = /*#__PURE__*/(() => {
  class ForgotPasswordModule {
    static {
      this.ɵfac = function ForgotPasswordModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ForgotPasswordModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ForgotPasswordModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            ForgotPasswordComponent: {
              component: ForgotPasswordComponent,
              guards: [NotAuthGuard],
              providers: [{
                provide: ForgotPasswordComponentService,
                useClass: ForgotPasswordComponentService,
                deps: [UserPasswordFacade, RoutingService, AuthConfigService, GlobalMessageService]
              }]
            }
          }
        })],
        imports: [CommonModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, FormErrorsModule, SpinnerModule, FeaturesConfigModule, BtnLikeLinkModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
      });
    }
  }
  return ForgotPasswordModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let RegisterComponentService = /*#__PURE__*/(() => {
  class RegisterComponentService {
    constructor(userRegisterFacade, globalMessageService, fb) {
      this.userRegisterFacade = userRegisterFacade;
      this.globalMessageService = globalMessageService;
      this.fb = fb;
      this.featureConfigService = inject(FeatureConfigService);
    }
    /**
     * Register a new user.
     *
     * @param user as UserSignUp
     */
    register(user) {
      return this.userRegisterFacade.register(user);
    }
    /**
     * Returns titles that can be used for the user profiles.
     */
    getTitles() {
      return this.userRegisterFacade.getTitles();
    }
    /**
     * Show the message after successful registration.
     */
    postRegisterMessage() {
      if (this.featureConfigService.isEnabled('a11yPostRegisterSuccessMessage')) {
        this.globalMessageService.add({
          key: 'register.postRegisterSuccessMessage'
        }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      } else {
        this.globalMessageService.add({
          key: 'register.postRegisterMessage'
        }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      }
    }
    /**
     * Get if any additional consents needs to be provided during registration
     * In core feature, no additional consents are necessary during registration.
     * In integration scenarios, eg: cdc, this method will be overridden to return
     * necessary cdc consents
     */
    getAdditionalConsents() {
      return [];
    }
    /**
     * Generate form control if any additional consents that needs to be provided during registration
     * In core feature, no additional consents are necessary during registration.
     * In integration scenarios, eg: cdc, this method will be overridden to return
     * form controls for necessary cdc consents
     */
    generateAdditionalConsentsFormControl() {
      return this.fb?.array([]) ?? undefined;
    }
    collectDataFromRegisterForm(formData) {
      const {
        firstName,
        lastName,
        email,
        password,
        titleCode
      } = formData;
      return {
        firstName,
        lastName,
        password,
        titleCode,
        uid: email.toLowerCase()
      };
    }
    static {
      this.ɵfac = function RegisterComponentService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RegisterComponentService)(i0.ɵɵinject(i1.UserRegisterFacade), i0.ɵɵinject(i2.GlobalMessageService), i0.ɵɵinject(i3.UntypedFormBuilder));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RegisterComponentService,
        factory: RegisterComponentService.ɵfac
      });
    }
  }
  return RegisterComponentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let RegisterComponent = /*#__PURE__*/(() => {
  class RegisterComponent {
    get additionalConsents() {
      return this.registerForm?.get('additionalConsents');
    }
    updateAdditionalConsents(event, index) {
      const {
        checked
      } = event.target;
      this.registerForm.value.additionalConsents[index].isConsentGranted = checked;
    }
    constructor(globalMessageService, fb, router, anonymousConsentsService, anonymousConsentsConfig, authConfigService, registerComponentService) {
      this.globalMessageService = globalMessageService;
      this.fb = fb;
      this.router = router;
      this.anonymousConsentsService = anonymousConsentsService;
      this.anonymousConsentsConfig = anonymousConsentsConfig;
      this.authConfigService = authConfigService;
      this.registerComponentService = registerComponentService;
      // TODO: (CXSPA-7315) Remove feature toggle in the next major
      // TODO: (CXSPA-8550) Remove feature toggle
      this.featureConfigService = inject(FeatureConfigService);
      this.passwordValidators = this.featureConfigService?.isEnabled('formErrorsDescriptiveMessages') ? this.featureConfigService.isEnabled('enableSecurePasswordValidation') ? CustomFormValidators.securePasswordValidators : this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement') ? [...CustomFormValidators.passwordValidators, CustomFormValidators.noConsecutiveCharacters] : CustomFormValidators.passwordValidators : [this.featureConfigService.isEnabled('enableSecurePasswordValidation') ? CustomFormValidators.securePasswordValidator : this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement') ? CustomFormValidators.strongPasswordValidator : CustomFormValidators.passwordValidator];
      this.isLoading$ = new BehaviorSubject(false);
      this.subscription = new Subscription();
      this.registerForm = this.fb.group({
        titleCode: [null],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        email: ['', [Validators.required, CustomFormValidators.emailValidator]],
        password: ['', [Validators.required, ...this.passwordValidators]],
        passwordconf: ['', Validators.required],
        newsletter: new UntypedFormControl({
          value: false,
          disabled: this.isConsentRequired()
        }),
        additionalConsents: this.registerComponentService.generateAdditionalConsentsFormControl?.() ?? this.fb.array([]),
        termsandconditions: [false, Validators.requiredTrue],
        captcha: [false, Validators.requiredTrue]
      }, {
        validators: CustomFormValidators.passwordsMustMatch('password', 'passwordconf')
      });
      useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
    }
    ngOnInit() {
      this.titles$ = this.registerComponentService.getTitles().pipe(map(titles => {
        return titles.sort(sortTitles);
      }));
      // TODO: Workaround: allow server for decide is titleCode mandatory (if yes, provide personalized message)
      this.subscription.add(this.globalMessageService.get().pipe(filter(messages => !!Object.keys(messages).length)).subscribe(globalMessageEntities => {
        const messages = globalMessageEntities && globalMessageEntities[GlobalMessageType.MSG_TYPE_ERROR];
        if (messages && messages.some(message => message.raw === 'This field is required.')) {
          this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
          this.globalMessageService.add({
            key: 'register.titleRequired'
          }, GlobalMessageType.MSG_TYPE_ERROR);
        }
      }));
      const registerConsent = this.anonymousConsentsConfig?.anonymousConsents?.registerConsent ?? '';
      this.anonymousConsent$ = combineLatest([this.anonymousConsentsService.getConsent(registerConsent), this.anonymousConsentsService.getTemplate(registerConsent)]).pipe(map(([consent, template]) => {
        return {
          consent,
          template: template?.description ? template.description : ''
        };
      }));
      this.additionalRegistrationConsents = this.registerComponentService?.getAdditionalConsents() || [];
      this.subscription.add(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.registerForm.get('newsletter').valueChanges.subscribe(() => {
        this.toggleAnonymousConsent();
      }));
    }
    submitForm() {
      if (this.registerForm.valid) {
        this.registerUser();
      } else {
        this.registerForm.markAllAsTouched();
      }
    }
    registerUser() {
      this.isLoading$.next(true);
      this.registerComponentService.register(this.collectDataFromRegisterForm(this.registerForm.value)).subscribe({
        next: () => this.onRegisterUserSuccess(),
        complete: () => this.isLoading$.next(false),
        error: () => this.isLoading$.next(false)
      });
    }
    titleSelected(title) {
      this.registerForm['controls'].titleCode.setValue(title.code);
    }
    collectDataFromRegisterForm(formData) {
      return this.registerComponentService.collectDataFromRegisterForm(formData);
    }
    isConsentGiven(consent) {
      return this.anonymousConsentsService.isConsentGiven(consent);
    }
    isConsentRequired() {
      const requiredConsents = this.anonymousConsentsConfig?.anonymousConsents?.requiredConsents;
      const registerConsent = this.anonymousConsentsConfig?.anonymousConsents?.registerConsent;
      if (requiredConsents && registerConsent) {
        return requiredConsents.includes(registerConsent);
      }
      return false;
    }
    onRegisterUserSuccess() {
      if (this.authConfigService.getOAuthFlow() === OAuthFlow.ResourceOwnerPasswordFlow) {
        this.router.go('login');
      }
      this.registerComponentService.postRegisterMessage();
    }
    toggleAnonymousConsent() {
      const registerConsent = this.anonymousConsentsConfig?.anonymousConsents?.registerConsent;
      if (registerConsent) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (Boolean(this.registerForm.get('newsletter').value)) {
          this.anonymousConsentsService.giveConsent(registerConsent);
        } else {
          this.anonymousConsentsService.withdrawConsent(registerConsent);
        }
      }
    }
    /**
     * Triggered via CaptchaComponent when a user confirms captcha
     */
    captchaConfirmed() {
      this.registerForm.get('captcha')?.setValue(true);
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static {
      this.ɵfac = function RegisterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RegisterComponent)(i0.ɵɵdirectiveInject(i2.GlobalMessageService), i0.ɵɵdirectiveInject(i3.UntypedFormBuilder), i0.ɵɵdirectiveInject(i2.RoutingService), i0.ɵɵdirectiveInject(i2.AnonymousConsentsService), i0.ɵɵdirectiveInject(i2.AnonymousConsentsConfig), i0.ɵɵdirectiveInject(i2.AuthConfigService), i0.ɵɵdirectiveInject(RegisterComponentService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RegisterComponent,
        selectors: [["cx-register"]],
        standalone: false,
        decls: 4,
        vars: 4,
        consts: [["loading", ""], ["class", "cx-page-section container", 4, "ngIf", "ngIfElse"], [1, "cx-page-section", "container"], ["role", "status", 4, "cxFeature"], [1, "row", "justify-content-center"], [1, "col-md-6"], [1, "cx-section"], [3, "ngSubmit", "formGroup"], [1, "form-group"], [1, "label-content"], ["bindLabel", "name", "bindValue", "code", "formControlName", "titleCode", "id", "title-select", 3, "clearable", "items", "placeholder", "searchable", "cxNgSelectA11y"], ["required", "true", "type", "text", "name", "firstname", "formControlName", "firstName", 1, "form-control", 3, "placeholder"], ["id", "firstNameError", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "text", "name", "lastname", "formControlName", "lastName", 1, "form-control", 3, "placeholder"], ["id", "lastNameError", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "email", "name", "email", "formControlName", "email", 1, "form-control", 3, "placeholder"], ["id", "emailError", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "password", "formControlName", "password", "aria-describedby", "password-input-hint", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "password-input-hint", 1, "input-hint"], [3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "confirmpassword", "formControlName", "passwordconf", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordconfError", 3, "translationParams", "control", 4, "cxFeature"], [1, "form-check"], [4, "ngIf"], ["formArrayName", "additionalConsents", "class", "form-group", 4, "ngIf"], ["required", "true", "type", "checkbox", "name", "termsandconditions", "formControlName", "termsandconditions"], [1, "form-check-label"], ["target", "_blank", "rel", "noopener noreferrer", 3, "routerLink"], ["id", "termsandconditionsError", 3, "translationParams", "control", 4, "cxFeature"], [3, "confirmed"], [3, "control"], ["type", "submit", 1, "btn", "btn-block", "btn-primary"], [1, "cx-login-link", "btn-link", 3, "routerLink"], ["role", "status"], ["id", "firstNameError", 3, "translationParams", "control"], ["id", "lastNameError", 3, "translationParams", "control"], ["id", "emailError", 3, "translationParams", "control"], [3, "translationParams", "control"], ["id", "passwordconfError", 3, "translationParams", "control"], ["type", "checkbox", "name", "newsletter", "formControlName", "newsletter", 1, "form-check-input", 3, "checked"], ["formArrayName", "additionalConsents", 1, "form-group"], ["class", "form-check", 3, "formGroupName", 4, "ngFor", "ngForOf"], [1, "form-check", 3, "formGroupName"], ["type", "checkbox", "formControlName", "isConsentGranted", 3, "change", "required", "name"], ["id", "termsandconditionsError", 3, "translationParams", "control"], [1, "cx-spinner"]],
        template: function RegisterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, RegisterComponent_section_0_Template, 98, 101, "section", 1);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, RegisterComponent_ng_template_2_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const loading_r10 = i0.ɵɵreference(3);
            i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(1, 2, ctx.isLoading$))("ngIfElse", loading_r10);
          }
        },
        dependencies: [i4.CaptchaComponent, i2$1.NgForOf, i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.CheckboxRequiredValidator, i3.FormGroupDirective, i3.FormControlName, i3.FormGroupName, i3.FormArrayName, i5.RouterLink, i4.SpinnerComponent, i4.FormErrorsComponent, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i4.NgSelectA11yDirective, i6.NgSelectComponent, i4.PasswordVisibilityToggleDirective, i2.FeatureDirective, i2$1.AsyncPipe, i2.UrlPipe, i2.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return RegisterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let RegisterComponentModule = /*#__PURE__*/(() => {
  class RegisterComponentModule {
    static {
      this.ɵfac = function RegisterComponentModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RegisterComponentModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: RegisterComponentModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            RegisterCustomerComponent: {
              component: RegisterComponent,
              guards: [NotAuthGuard],
              providers: [{
                provide: RegisterComponentService,
                useClass: RegisterComponentService,
                deps: [UserRegisterFacade, GlobalMessageService, UntypedFormBuilder]
              }]
            }
          }
        })],
        imports: [CaptchaModule, CommonModule, ReactiveFormsModule, RouterModule, UrlModule, I18nModule, SpinnerModule, FormErrorsModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent, NgSelectA11yModule, NgSelectModule, PasswordVisibilityToggleModule, FeaturesConfigModule]
      });
    }
  }
  return RegisterComponentModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ResetPasswordComponentService = /*#__PURE__*/(() => {
  class ResetPasswordComponentService {
    constructor(userPasswordService, routingService, globalMessage) {
      this.userPasswordService = userPasswordService;
      this.routingService = routingService;
      this.globalMessage = globalMessage;
      // TODO: (CXSPA-7315) Remove feature toggle in the next major
      // TODO: (CXSPA-8550) Remove feature toggle
      this.featureConfigService = inject(FeatureConfigService);
      this.passwordValidators = this.featureConfigService?.isEnabled('formErrorsDescriptiveMessages') ? this.featureConfigService.isEnabled('enableSecurePasswordValidation') ? CustomFormValidators.securePasswordValidators : this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement') ? [...CustomFormValidators.passwordValidators, CustomFormValidators.noConsecutiveCharacters] : CustomFormValidators.passwordValidators : [this.featureConfigService.isEnabled('enableSecurePasswordValidation') ? CustomFormValidators.securePasswordValidator : this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement') ? CustomFormValidators.strongPasswordValidator : CustomFormValidators.passwordValidator];
      this.busy$ = new BehaviorSubject(false);
      this.isUpdating$ = this.busy$.pipe(tap(state => state === true ? this.form.disable() : this.form.enable()));
      this.resetToken$ = this.routingService.getRouterState().pipe(map(routerState => routerState.state.queryParams['token']));
      this.form = new UntypedFormGroup({
        password: new UntypedFormControl('', [Validators.required, ...this.passwordValidators]),
        passwordConfirm: new UntypedFormControl('', Validators.required)
      }, {
        validators: CustomFormValidators.passwordsMustMatch('password', 'passwordConfirm')
      });
    }
    /**
     * Resets the password by the given token.
     *
     * The token has been provided during the request password flow.
     * The token is not validated on the client.
     */
    resetPassword(token) {
      if (!this.form.valid) {
        this.form.markAllAsTouched();
        return;
      }
      this.busy$.next(true);
      const password = this.form.get('password').value;
      this.userPasswordService.reset(token, password).subscribe({
        next: () => this.onSuccess(),
        error: error => this.onError(error)
      });
    }
    onSuccess() {
      this.globalMessage.add({
        key: 'forgottenPassword.passwordResetSuccess'
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      this.busy$.next(false);
      this.form.reset();
      this.redirect();
    }
    onError(error) {
      this.busy$.next(false);
      if (error instanceof HttpErrorModel) {
        (error.details ?? []).forEach(err => {
          if (err.message) {
            this.globalMessage.add({
              raw: err.message
            }, GlobalMessageType.MSG_TYPE_ERROR);
          }
        });
      }
    }
    /**
     * Redirects the user to the login page.
     */
    redirect() {
      this.routingService.go({
        cxRoute: 'login'
      });
    }
    static {
      this.ɵfac = function ResetPasswordComponentService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ResetPasswordComponentService)(i0.ɵɵinject(i1.UserPasswordFacade), i0.ɵɵinject(i2.RoutingService), i0.ɵɵinject(i2.GlobalMessageService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ResetPasswordComponentService,
        factory: ResetPasswordComponentService.ɵfac
      });
    }
  }
  return ResetPasswordComponentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ResetPasswordComponent = /*#__PURE__*/(() => {
  class ResetPasswordComponent {
    constructor(service) {
      this.service = service;
      this.form = this.service.form;
      this.isUpdating$ = this.service.isUpdating$;
      this.token$ = this.service.resetToken$;
      useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
    }
    onSubmit(token) {
      this.service.resetPassword(token);
    }
    static {
      this.ɵfac = function ResetPasswordComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ResetPasswordComponent)(i0.ɵɵdirectiveInject(ResetPasswordComponentService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ResetPasswordComponent,
        selectors: [["cx-reset-password"]],
        hostAttrs: [1, "user-form"],
        standalone: false,
        decls: 4,
        vars: 6,
        consts: [["class", "overlay", 4, "ngIf"], [3, "formGroup", "ngSubmit", 4, "ngIf"], [1, "overlay"], [3, "ngSubmit", "formGroup"], [1, "label-content"], ["required", "true", "type", "password", "formControlName", "password", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordError", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "password", "formControlName", "passwordConfirm", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordConfirmError", 3, "translationParams", "control", 4, "cxFeature"], [1, "btn", "btn-block", "btn-primary", 3, "disabled"], ["id", "passwordError", 3, "translationParams", "control"], [3, "control"], ["id", "passwordConfirmError", 3, "translationParams", "control"]],
        template: function ResetPasswordComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ResetPasswordComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, ResetPasswordComponent_form_2_Template, 25, 31, "form", 1);
            i0.ɵɵpipe(3, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.isUpdating$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx.token$));
          }
        },
        dependencies: [i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.FormErrorsComponent, i4.SpinnerComponent, i4.PasswordVisibilityToggleDirective, i2.FeatureDirective, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i2$1.AsyncPipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return ResetPasswordComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ResetPasswordModule = /*#__PURE__*/(() => {
  class ResetPasswordModule {
    static {
      this.ɵfac = function ResetPasswordModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ResetPasswordModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ResetPasswordModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            ResetPasswordComponent: {
              component: ResetPasswordComponent,
              guards: [NotAuthGuard],
              providers: [{
                provide: ResetPasswordComponentService,
                useClass: ResetPasswordComponentService,
                deps: [UserPasswordFacade, RoutingService, GlobalMessageService]
              }]
            }
          }
        })],
        imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, I18nModule, FormErrorsModule, SpinnerModule, PasswordVisibilityToggleModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
      });
    }
  }
  return ResetPasswordModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UpdateEmailComponentService = /*#__PURE__*/(() => {
  class UpdateEmailComponentService {
    constructor(userEmail, routingService, globalMessageService, authService, authRedirectService) {
      this.userEmail = userEmail;
      this.routingService = routingService;
      this.globalMessageService = globalMessageService;
      this.authService = authService;
      this.authRedirectService = authRedirectService;
      this.busy$ = new BehaviorSubject(false);
      this.updateSucceed$ = new Subject();
      this.isUpdating$ = this.busy$.pipe(tap(state => state === true ? this.form.disable() : this.form.enable()));
      this.form = new UntypedFormGroup({
        email: new UntypedFormControl('', [Validators.required, CustomFormValidators.emailValidator]),
        confirmEmail: new UntypedFormControl('', [Validators.required]),
        password: new UntypedFormControl('', [Validators.required])
      }, {
        validators: CustomFormValidators.emailsMustMatch('email', 'confirmEmail')
      });
    }
    save() {
      if (!this.form.valid) {
        this.form.markAllAsTouched();
        return;
      }
      this.busy$.next(true);
      const newEmail = this.form.get('confirmEmail')?.value;
      const password = this.form.get('password')?.value;
      this.userEmail.update(password, newEmail).subscribe({
        next: () => this.onSuccess(newEmail),
        error: error => this.onError(error)
      });
    }
    /**
     * Handles successful updating of the user email.
     */
    onSuccess(newUid) {
      this.globalMessageService.add({
        key: 'updateEmailForm.emailUpdateSuccess',
        params: {
          newUid
        }
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      this.busy$.next(false);
      this.form.reset();
      this.updateSucceed$.next(true);
      // sets the redirect url after login
      this.authRedirectService.setRedirectUrl(this.routingService.getUrl({
        cxRoute: 'home'
      }));
      // TODO(#9638): Use logout route when it will support passing redirect url
      this.authService.coreLogout().then(() => {
        this.routingService.go({
          cxRoute: 'login'
        }, {
          state: {
            newUid
          }
        });
      });
    }
    onError(_error) {
      this.busy$.next(false);
      this.updateSucceed$.next(false);
    }
    static {
      this.ɵfac = function UpdateEmailComponentService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UpdateEmailComponentService)(i0.ɵɵinject(i1.UserEmailFacade), i0.ɵɵinject(i2.RoutingService), i0.ɵɵinject(i2.GlobalMessageService), i0.ɵɵinject(i2.AuthService), i0.ɵɵinject(i2.AuthRedirectService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UpdateEmailComponentService,
        factory: UpdateEmailComponentService.ɵfac
      });
    }
  }
  return UpdateEmailComponentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UpdateEmailComponent = /*#__PURE__*/(() => {
  class UpdateEmailComponent {
    constructor(service) {
      this.service = service;
      this.form = this.service.form;
      this.isUpdating$ = this.service.isUpdating$;
      useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
    }
    onSubmit() {
      this.service.save();
    }
    static {
      this.ɵfac = function UpdateEmailComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UpdateEmailComponent)(i0.ɵɵdirectiveInject(UpdateEmailComponentService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: UpdateEmailComponent,
        selectors: [["cx-update-email"]],
        hostAttrs: [1, "user-form"],
        standalone: false,
        decls: 39,
        vars: 47,
        consts: [["class", "overlay", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [1, "label-content"], ["required", "true", "type", "email", "name", "email", "formControlName", "email", 1, "form-control", 3, "placeholder"], ["id", "emailError", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "email", "name", "confirmEmail", "formControlName", "confirmEmail", 1, "form-control", 3, "placeholder"], ["id", "confirmEmailError", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "password", "formControlName", "password", "autocomplete", "new-password", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordError", 3, "translationParams", "control", 4, "cxFeature"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"], [1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "overlay"], ["id", "emailError", 3, "translationParams", "control"], [3, "control"], ["id", "confirmEmailError", 3, "translationParams", "control"], ["id", "passwordError", 3, "translationParams", "control"]],
        template: function UpdateEmailComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, UpdateEmailComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelement(2, "cx-form-required-legend");
            i0.ɵɵelementStart(3, "form", 1);
            i0.ɵɵlistener("ngSubmit", function UpdateEmailComponent_Template_form_ngSubmit_3_listener() {
              return ctx.onSubmit();
            });
            i0.ɵɵelementStart(4, "label")(5, "span", 2);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "cxTranslate");
            i0.ɵɵelement(8, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "input", 3);
            i0.ɵɵpipe(10, "cxTranslate");
            i0.ɵɵtemplate(11, UpdateEmailComponent_cx_form_errors_11_Template, 2, 6, "cx-form-errors", 4)(12, UpdateEmailComponent_cx_form_errors_12_Template, 1, 1, "cx-form-errors", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "label")(14, "span", 2);
            i0.ɵɵtext(15);
            i0.ɵɵpipe(16, "cxTranslate");
            i0.ɵɵelement(17, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(18, "input", 6);
            i0.ɵɵpipe(19, "cxTranslate");
            i0.ɵɵtemplate(20, UpdateEmailComponent_cx_form_errors_20_Template, 2, 6, "cx-form-errors", 7)(21, UpdateEmailComponent_cx_form_errors_21_Template, 1, 1, "cx-form-errors", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "label")(23, "span", 2);
            i0.ɵɵtext(24);
            i0.ɵɵpipe(25, "cxTranslate");
            i0.ɵɵelement(26, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(27, "input", 8);
            i0.ɵɵpipe(28, "cxTranslate");
            i0.ɵɵpipe(29, "cxTranslate");
            i0.ɵɵtemplate(30, UpdateEmailComponent_cx_form_errors_30_Template, 2, 6, "cx-form-errors", 9)(31, UpdateEmailComponent_cx_form_errors_31_Template, 1, 1, "cx-form-errors", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(32, "a", 10);
            i0.ɵɵpipe(33, "cxUrl");
            i0.ɵɵtext(34);
            i0.ɵɵpipe(35, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(36, "button", 11);
            i0.ɵɵtext(37);
            i0.ɵɵpipe(38, "cxTranslate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_4_0;
            let tmp_10_0;
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 24, ctx.isUpdating$));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 26, "updateEmailForm.newEmailAddress.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 28, "updateEmailForm.newEmailAddress.placeholder"));
            i0.ɵɵattribute("aria-invalid", ((tmp_4_0 = ctx.form.get("email")) == null ? null : tmp_4_0.touched) && ((tmp_4_0 = ctx.form.get("email")) == null ? null : tmp_4_0.invalid))("aria-errormessage", "emailError");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(16, 30, "updateEmailForm.confirmNewEmailAddress.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(19, 32, "updateEmailForm.confirmNewEmailAddress.placeholder"));
            i0.ɵɵattribute("aria-invalid", ((tmp_10_0 = ctx.form.get("confirmEmail")) == null ? null : tmp_10_0.touched) && ((tmp_10_0 = ctx.form.get("confirmEmail")) == null ? null : tmp_10_0.invalid))("aria-errormessage", "confirmEmailError");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(25, 34, "updateEmailForm.password.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(28, 36, "updateEmailForm.password.placeholder"));
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(29, 38, "updateEmailForm.password.placeholder"))("aria-describedby", "passwordError");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(33, 40, i0.ɵɵpureFunction0(46, _c1)));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(35, 42, "common.cancel"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.form.disabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(38, 44, "common.save"), " ");
          }
        },
        dependencies: [i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.SpinnerComponent, i5.RouterLink, i4.FormErrorsComponent, i4.PasswordVisibilityToggleDirective, i2.FeatureDirective, i4.BtnLikeLinkDirective, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i2$1.AsyncPipe, i2.UrlPipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return UpdateEmailComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let MyAccountV2EmailComponent = /*#__PURE__*/(() => {
  class MyAccountV2EmailComponent {
    constructor() {
      this.emailComponentService = inject(UpdateEmailComponentService);
      this.userProfile = inject(UserProfileFacade);
      this.form = this.emailComponentService.form;
      this.isUpdating$ = this.emailComponentService.isUpdating$;
      this.user$ = this.userProfile.get().pipe(filter(user => Boolean(user)));
      this.globalMessageType = GlobalMessageType;
    }
    ngOnInit() {
      this.isEditing = false;
    }
    onSubmit() {
      this.emailComponentService.save();
      this.emailComponentService.updateSucceed$.subscribe(res => {
        this.isEditing = !res;
      });
    }
    onEdit() {
      this.isEditing = true;
      this.showingAlert = true;
      this.form.reset();
    }
    cancelEdit() {
      this.isEditing = false;
    }
    closeDialogConfirmationAlert() {
      this.showingAlert = false;
    }
    static {
      this.ɵfac = function MyAccountV2EmailComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MyAccountV2EmailComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MyAccountV2EmailComponent,
        selectors: [["cx-my-account-v2-email"]],
        standalone: false,
        decls: 13,
        vars: 12,
        consts: [["class", "overlay", 4, "ngIf$", "ngIf"], [1, "flex-line"], [1, "headertext"], ["class", "editButton", 3, "click", 4, "ngIf"], [4, "ngIf"], [3, "text", "type", "closeMessage", 4, "ngIf"], ["class", "email-editing-area", 4, "ngIf"], [1, "overlay"], [1, "editButton", 3, "click"], [1, "text-head"], [1, "value"], [3, "closeMessage", "text", "type"], [1, "email-editing-area"], [3, "ngSubmit", "formGroup"], ["type", "text", "readonly", "", 1, "form-control", 3, "value"], ["required", "true", "type", "email", "name", "email", "formControlName", "email", 1, "form-control", 3, "placeholder"], ["id", "emailError", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "email", "name", "confirmEmail", "formControlName", "confirmEmail", 1, "form-control", 3, "placeholder"], ["id", "confirmEmailError", 3, "translationParams", "control", 4, "cxFeature"], [1, "label-content,", "text-head"], ["required", "true", "type", "password", "name", "password", "formControlName", "password", "autocomplete", "new-password", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "passwordError", 3, "translationParams", "control", 4, "cxFeature"], [1, "btn-group"], [1, "btn", "button-cancel", "button", 3, "click"], [1, "btn", "btn-primary", "button", 3, "click", "disabled"], ["id", "emailError", 3, "translationParams", "control"], [3, "control"], ["id", "confirmEmailError", 3, "translationParams", "control"], ["id", "passwordError", 3, "translationParams", "control"]],
        template: function MyAccountV2EmailComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MyAccountV2EmailComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelementStart(3, "div")(4, "div", 1)(5, "label", 2);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, MyAccountV2EmailComponent_button_8_Template, 3, 3, "button", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div");
            i0.ɵɵtemplate(10, MyAccountV2EmailComponent_div_10_Template, 8, 6, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, MyAccountV2EmailComponent_cx_message_11_Template, 2, 4, "cx-message", 5)(12, MyAccountV2EmailComponent_div_12_Template, 40, 47, "div", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 6, ctx.isUpdating$) || !i0.ɵɵpipeBind1(2, 8, ctx.user$));
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 10, "myAccountV2Email.myEmailAddress"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.isEditing);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.isEditing);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isEditing && ctx.showingAlert);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isEditing);
          }
        },
        dependencies: [i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.SpinnerComponent, i4.FormErrorsComponent, i4.PasswordVisibilityToggleDirective, i2.FeatureDirective, i4.MessageComponent, i2$1.AsyncPipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MyAccountV2EmailComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const USE_MY_ACCOUNT_V2_EMAIL = new InjectionToken('feature flag to enable enhanced UI for email related pages under My-Account', {
  providedIn: 'root',
  factory: () => false
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const myAccountV2EmailMapping = {
  cmsComponents: {
    UpdateEmailComponent: {
      component: MyAccountV2EmailComponent
    }
  }
};
let UpdateEmailModule = /*#__PURE__*/(() => {
  class UpdateEmailModule {
    static {
      this.ɵfac = function UpdateEmailModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UpdateEmailModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: UpdateEmailModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            UpdateEmailComponent: {
              component: UpdateEmailComponent,
              guards: [AuthGuard],
              providers: [{
                provide: UpdateEmailComponentService,
                useClass: UpdateEmailComponentService,
                deps: [UserEmailFacade, RoutingService, GlobalMessageService, AuthService, AuthRedirectService]
              }]
            }
          }
        }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_EMAIL) ? myAccountV2EmailMapping : {})],
        imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, UrlModule, RouterModule, I18nModule, FormErrorsModule, PasswordVisibilityToggleModule, FeaturesConfigModule, MessageComponentModule, BtnLikeLinkModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
      });
    }
  }
  return UpdateEmailModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const USE_MY_ACCOUNT_V2_PASSWORD = new InjectionToken('feature flag to enable enhanced UI for Update Password related pages under My-Account', {
  providedIn: 'root',
  factory: () => false
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UpdatePasswordComponentService = /*#__PURE__*/(() => {
  class UpdatePasswordComponentService {
    constructor(userPasswordService, routingService, globalMessageService, authRedirectService, authService) {
      this.userPasswordService = userPasswordService;
      this.routingService = routingService;
      this.globalMessageService = globalMessageService;
      this.authRedirectService = authRedirectService;
      this.authService = authService;
      // TODO: (CXSPA-7315) Remove feature toggle in the next major
      // TODO: (CXSPA-8550) Remove feature toggle
      this.featureConfigService = inject(FeatureConfigService);
      this.passwordValidators = this.featureConfigService?.isEnabled('formErrorsDescriptiveMessages') ? this.featureConfigService.isEnabled('enableSecurePasswordValidation') ? CustomFormValidators.securePasswordValidators : this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement') ? [...CustomFormValidators.passwordValidators, CustomFormValidators.noConsecutiveCharacters] : CustomFormValidators.passwordValidators : [this.featureConfigService.isEnabled('enableSecurePasswordValidation') ? CustomFormValidators.securePasswordValidator : this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement') ? CustomFormValidators.strongPasswordValidator : CustomFormValidators.passwordValidator];
      this.busy$ = new BehaviorSubject(false);
      this.usingV2 = inject(USE_MY_ACCOUNT_V2_PASSWORD);
      this.isUpdating$ = this.busy$.pipe(tap(state => state === true ? this.form.disable() : this.form.enable()));
      this.form = new UntypedFormGroup({
        oldPassword: new UntypedFormControl('', Validators.required),
        newPassword: new UntypedFormControl('', [Validators.required, ...this.passwordValidators]),
        newPasswordConfirm: new UntypedFormControl('', Validators.required)
      }, {
        validators: this.getPasswordValidators()
      });
    }
    /**
     * Updates the password for the user.
     */
    updatePassword() {
      if (!this.form.valid) {
        this.form.markAllAsTouched();
        return;
      }
      this.busy$.next(true);
      const oldPassword = this.form.get('oldPassword')?.value;
      const newPassword = this.form.get('newPassword')?.value;
      this.userPasswordService.update(oldPassword, newPassword).subscribe({
        next: () => this.onSuccess(),
        error: error => this.onError(error)
      });
    }
    onSuccess() {
      this.globalMessageService.add({
        key: this.usingV2 ? 'myAccountV2PasswordForm.passwordUpdateSuccess' : 'updatePasswordForm.passwordUpdateSuccess'
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      this.busy$.next(false);
      this.form.reset();
      // sets the redirect url after login
      this.authRedirectService?.setRedirectUrl(this.routingService.getUrl({
        cxRoute: 'home'
      }));
      // TODO(#9638): Use logout route when it will support passing redirect url
      this.authService?.coreLogout().then(() => {
        this.routingService.go({
          cxRoute: 'login'
        });
      });
    }
    onError(_error) {
      if (_error instanceof HttpErrorModel && _error.details?.[0].type === 'AccessDeniedError') {
        this.globalMessageService.add({
          key: this.usingV2 ? 'myAccountV2PasswordForm.accessDeniedError' : 'updatePasswordForm.accessDeniedError'
        }, GlobalMessageType.MSG_TYPE_ERROR);
      }
      this.busy$.next(false);
      this.form.reset();
    }
    // TODO: (CXSPA-8550) Remove after removing enablePasswordsCannotMatchInPasswordUpdateForm feature toggle
    getPasswordValidators() {
      const passwordMustMatchValidator = CustomFormValidators.passwordsMustMatch('newPassword', 'newPasswordConfirm');
      return this.featureConfigService.isEnabled('enablePasswordsCannotMatchInPasswordUpdateForm') ? [passwordMustMatchValidator, CustomFormValidators.passwordsCannotMatch('oldPassword', 'newPassword')] : [passwordMustMatchValidator];
    }
    static {
      this.ɵfac = function UpdatePasswordComponentService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UpdatePasswordComponentService)(i0.ɵɵinject(i1.UserPasswordFacade), i0.ɵɵinject(i2.RoutingService), i0.ɵɵinject(i2.GlobalMessageService), i0.ɵɵinject(i2.AuthRedirectService), i0.ɵɵinject(i2.AuthService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UpdatePasswordComponentService,
        factory: UpdatePasswordComponentService.ɵfac
      });
    }
  }
  return UpdatePasswordComponentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UpdatePasswordComponent = /*#__PURE__*/(() => {
  class UpdatePasswordComponent {
    constructor(service) {
      this.service = service;
      this.routingService = inject(RoutingService, {
        optional: true
      });
      this.form = this.service.form;
      this.isUpdating$ = this.service.isUpdating$;
      useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
    }
    onSubmit() {
      this.service.updatePassword();
    }
    navigateTo(cxRoute) {
      this.routingService?.go({
        cxRoute
      });
    }
    static {
      this.ɵfac = function UpdatePasswordComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UpdatePasswordComponent)(i0.ɵɵdirectiveInject(UpdatePasswordComponentService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: UpdatePasswordComponent,
        selectors: [["cx-update-password"]],
        hostAttrs: [1, "user-form"],
        standalone: false,
        decls: 39,
        vars: 49,
        consts: [["class", "overlay", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [1, "label-content"], ["required", "true", "type", "password", "name", "oldPassword", "formControlName", "oldPassword", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "oldPasswordError", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "newPassword", "formControlName", "newPassword", "aria-describedby", "password-input-hint", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "newPasswordError", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "newPasswordConfirm", "formControlName", "newPasswordConfirm", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "newPasswordConfirmError", 3, "translationParams", "control", 4, "cxFeature"], [4, "cxFeature"], [1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "overlay"], ["id", "oldPasswordError", 3, "translationParams", "control"], [3, "control"], ["id", "newPasswordError", 3, "translationParams", "control"], ["id", "newPasswordConfirmError", 3, "translationParams", "control"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"]],
        template: function UpdatePasswordComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, UpdatePasswordComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelement(2, "cx-form-required-legend");
            i0.ɵɵelementStart(3, "form", 1);
            i0.ɵɵlistener("ngSubmit", function UpdatePasswordComponent_Template_form_ngSubmit_3_listener() {
              return ctx.onSubmit();
            });
            i0.ɵɵelementStart(4, "label")(5, "span", 2);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "cxTranslate");
            i0.ɵɵelement(8, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "input", 3);
            i0.ɵɵpipe(10, "cxTranslate");
            i0.ɵɵpipe(11, "cxTranslate");
            i0.ɵɵtemplate(12, UpdatePasswordComponent_cx_form_errors_12_Template, 2, 6, "cx-form-errors", 4)(13, UpdatePasswordComponent_cx_form_errors_13_Template, 1, 1, "cx-form-errors", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "label")(15, "span", 2);
            i0.ɵɵtext(16);
            i0.ɵɵpipe(17, "cxTranslate");
            i0.ɵɵelement(18, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(19, "input", 6);
            i0.ɵɵpipe(20, "cxTranslate");
            i0.ɵɵpipe(21, "cxTranslate");
            i0.ɵɵtemplate(22, UpdatePasswordComponent_cx_form_errors_22_Template, 2, 6, "cx-form-errors", 7)(23, UpdatePasswordComponent_cx_form_errors_23_Template, 1, 1, "cx-form-errors", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(24, "label")(25, "span", 2);
            i0.ɵɵtext(26);
            i0.ɵɵpipe(27, "cxTranslate");
            i0.ɵɵelement(28, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(29, "input", 8);
            i0.ɵɵpipe(30, "cxTranslate");
            i0.ɵɵpipe(31, "cxTranslate");
            i0.ɵɵtemplate(32, UpdatePasswordComponent_cx_form_errors_32_Template, 2, 6, "cx-form-errors", 9)(33, UpdatePasswordComponent_cx_form_errors_33_Template, 1, 1, "cx-form-errors", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(34, UpdatePasswordComponent_ng_container_34_Template, 4, 3, "ng-container", 10)(35, UpdatePasswordComponent_ng_container_35_Template, 5, 7, "ng-container", 10);
            i0.ɵɵelementStart(36, "button", 11);
            i0.ɵɵtext(37);
            i0.ɵɵpipe(38, "cxTranslate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_5_0;
            let tmp_12_0;
            let tmp_19_0;
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 27, ctx.isUpdating$));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 29, "updatePasswordForm.oldPassword.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 31, "updatePasswordForm.oldPassword.placeholder"));
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(11, 33, "updatePasswordForm.oldPassword.placeholder"))("aria-invalid", ((tmp_5_0 = ctx.form.get("oldPassword")) == null ? null : tmp_5_0.touched) && ((tmp_5_0 = ctx.form.get("oldPassword")) == null ? null : tmp_5_0.invalid))("aria-errormessage", "oldPasswordError");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(17, 35, "updatePasswordForm.newPassword.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(20, 37, "updatePasswordForm.newPassword.placeholder"));
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(21, 39, "updatePasswordForm.newPassword.placeholder"))("aria-invalid", ((tmp_12_0 = ctx.form.get("newPassword")) == null ? null : tmp_12_0.touched) && ((tmp_12_0 = ctx.form.get("newPassword")) == null ? null : tmp_12_0.invalid))("aria-errormessage", "newPasswordError");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(27, 41, "updatePasswordForm.confirmPassword.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(30, 43, "updatePasswordForm.confirmPassword.placeholder"));
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(31, 45, "updatePasswordForm.confirmPassword.placeholder"))("aria-invalid", ((tmp_19_0 = ctx.form.get("newPasswordConfirm")) == null ? null : tmp_19_0.touched) && ((tmp_19_0 = ctx.form.get("newPasswordConfirm")) == null ? null : tmp_19_0.invalid))("aria-errormessage", "newPasswordConfirmError");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "a11yUseButtonsForBtnLinks");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!a11yUseButtonsForBtnLinks");
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.form.disabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(38, 47, "common.save"), " ");
          }
        },
        dependencies: [i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.SpinnerComponent, i4.FormErrorsComponent, i5.RouterLink, i4.PasswordVisibilityToggleDirective, i2.FeatureDirective, i4.BtnLikeLinkDirective, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i2$1.AsyncPipe, i2.TranslatePipe, i2.UrlPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return UpdatePasswordComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let MyAccountV2PasswordComponent = /*#__PURE__*/(() => {
  class MyAccountV2PasswordComponent {
    constructor() {
      this.service = inject(UpdatePasswordComponentService);
      this.showingAlert = true;
      this.globalMessageType = GlobalMessageType;
      this.form = this.service.form;
      this.isUpdating$ = this.service.isUpdating$;
      useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
    }
    onSubmit() {
      this.service.updatePassword();
    }
    onCancel() {
      this.oldPassword = '';
      this.newPassword = '';
      this.newPasswordConfirm = '';
    }
    closeDialogConfirmationAlert() {
      this.showingAlert = false;
    }
    static {
      this.ɵfac = function MyAccountV2PasswordComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MyAccountV2PasswordComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MyAccountV2PasswordComponent,
        selectors: [["cx-my-account-v2-password"]],
        standalone: false,
        decls: 41,
        vars: 57,
        consts: [["class", "overlay", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [1, "myaccount-password-header"], [3, "text", "type", "closeMessage", 4, "ngIf"], [1, "myaccount-label-padding"], [1, "label-content", "myaccount-password-label"], ["required", "true", "type", "password", "name", "oldPassword", "formControlName", "oldPassword", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "ngModelChange", "ngModel", "placeholder"], ["id", "oldPasswordError", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "newPassword", "formControlName", "newPassword", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "ngModelChange", "ngModel", "placeholder"], ["id", "newPasswordError", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "newPasswordConfirm", "formControlName", "newPasswordConfirm", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "ngModelChange", "ngModel", "placeholder"], ["id", "newPasswordConfirmError", 3, "translationParams", "control", 4, "cxFeature"], [1, "password-btn-group"], [1, "btn", "myaccount-password-button", "myaccount-password-button-cancel", 3, "click"], [1, "btn", "btn-primary", "myaccount-password-button", 3, "disabled"], [1, "overlay"], [3, "closeMessage", "text", "type"], ["id", "oldPasswordError", 3, "translationParams", "control"], [3, "control"], ["id", "newPasswordError", 3, "translationParams", "control"], ["id", "newPasswordConfirmError", 3, "translationParams", "control"]],
        template: function MyAccountV2PasswordComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MyAccountV2PasswordComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelementStart(2, "form", 1);
            i0.ɵɵlistener("ngSubmit", function MyAccountV2PasswordComponent_Template_form_ngSubmit_2_listener() {
              return ctx.onSubmit();
            });
            i0.ɵɵelementStart(3, "label", 2);
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, MyAccountV2PasswordComponent_cx_message_6_Template, 2, 4, "cx-message", 3);
            i0.ɵɵelementStart(7, "label", 4)(8, "span", 5);
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "input", 6);
            i0.ɵɵpipe(12, "cxTranslate");
            i0.ɵɵpipe(13, "cxTranslate");
            i0.ɵɵtwoWayListener("ngModelChange", function MyAccountV2PasswordComponent_Template_input_ngModelChange_11_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.oldPassword, $event) || (ctx.oldPassword = $event);
              return $event;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(14, MyAccountV2PasswordComponent_cx_form_errors_14_Template, 2, 6, "cx-form-errors", 7)(15, MyAccountV2PasswordComponent_cx_form_errors_15_Template, 1, 1, "cx-form-errors", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "label", 4)(17, "span", 5);
            i0.ɵɵtext(18);
            i0.ɵɵpipe(19, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(20, "input", 9);
            i0.ɵɵpipe(21, "cxTranslate");
            i0.ɵɵpipe(22, "cxTranslate");
            i0.ɵɵtwoWayListener("ngModelChange", function MyAccountV2PasswordComponent_Template_input_ngModelChange_20_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.newPassword, $event) || (ctx.newPassword = $event);
              return $event;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(23, MyAccountV2PasswordComponent_cx_form_errors_23_Template, 2, 6, "cx-form-errors", 10)(24, MyAccountV2PasswordComponent_cx_form_errors_24_Template, 1, 1, "cx-form-errors", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "label", 4)(26, "span", 5);
            i0.ɵɵtext(27);
            i0.ɵɵpipe(28, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(29, "input", 11);
            i0.ɵɵpipe(30, "cxTranslate");
            i0.ɵɵpipe(31, "cxTranslate");
            i0.ɵɵtwoWayListener("ngModelChange", function MyAccountV2PasswordComponent_Template_input_ngModelChange_29_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.newPasswordConfirm, $event) || (ctx.newPasswordConfirm = $event);
              return $event;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(32, MyAccountV2PasswordComponent_cx_form_errors_32_Template, 2, 6, "cx-form-errors", 12)(33, MyAccountV2PasswordComponent_cx_form_errors_33_Template, 1, 1, "cx-form-errors", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(34, "div", 13)(35, "button", 14);
            i0.ɵɵlistener("click", function MyAccountV2PasswordComponent_Template_button_click_35_listener() {
              return ctx.onCancel();
            });
            i0.ɵɵtext(36);
            i0.ɵɵpipe(37, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(38, "button", 15);
            i0.ɵɵtext(39);
            i0.ɵɵpipe(40, "cxTranslate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            let tmp_8_0;
            let tmp_16_0;
            let tmp_24_0;
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 31, ctx.isUpdating$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(5, 33, "myAccountV2PasswordForm.newPasswordTitle"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showingAlert);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 35, "myAccountV2PasswordForm.oldPassword.label"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(12, 37, "myAccountV2PasswordForm.oldPassword.placeholder"));
            i0.ɵɵtwoWayProperty("ngModel", ctx.oldPassword);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(13, 39, "myAccountV2PasswordForm.oldPassword.placeholder"))("aria-invalid", ((tmp_8_0 = ctx.form.get("oldPassword")) == null ? null : tmp_8_0.touched) && ((tmp_8_0 = ctx.form.get("oldPassword")) == null ? null : tmp_8_0.invalid))("aria-errormessage", "oldPasswordError");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 41, "myAccountV2PasswordForm.newPassword.label"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(21, 43, "myAccountV2PasswordForm.newPassword.placeholder"));
            i0.ɵɵtwoWayProperty("ngModel", ctx.newPassword);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(22, 45, "myAccountV2PasswordForm.newPassword.placeholder"))("aria-invalid", ((tmp_16_0 = ctx.form.get("newPassword")) == null ? null : tmp_16_0.touched) && ((tmp_16_0 = ctx.form.get("newPassword")) == null ? null : tmp_16_0.invalid))("aria-errormessage", "newPasswordError");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(28, 47, "myAccountV2PasswordForm.confirmPassword.label"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(30, 49, "myAccountV2PasswordForm.confirmPassword.placeholder"));
            i0.ɵɵtwoWayProperty("ngModel", ctx.newPasswordConfirm);
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(31, 51, "myAccountV2PasswordForm.confirmPassword.placeholder"))("aria-invalid", ((tmp_24_0 = ctx.form.get("newPasswordConfirm")) == null ? null : tmp_24_0.touched) && ((tmp_24_0 = ctx.form.get("newPasswordConfirm")) == null ? null : tmp_24_0.invalid))("aria-errormessage", "newPasswordConfirmError");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(37, 53, "common.cancel"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.form.disabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(40, 55, "common.save"), " ");
          }
        },
        dependencies: [i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.SpinnerComponent, i4.FormErrorsComponent, i4.PasswordVisibilityToggleDirective, i2.FeatureDirective, i4.MessageComponent, i2$1.AsyncPipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MyAccountV2PasswordComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const myAccountV2PasswordMapping = {
  cmsComponents: {
    UpdatePasswordComponent: {
      component: MyAccountV2PasswordComponent
    }
  }
};
let UpdatePasswordModule = /*#__PURE__*/(() => {
  class UpdatePasswordModule {
    static {
      this.ɵfac = function UpdatePasswordModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UpdatePasswordModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: UpdatePasswordModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            UpdatePasswordComponent: {
              component: UpdatePasswordComponent,
              guards: [AuthGuard],
              providers: [{
                provide: UpdatePasswordComponentService,
                useClass: UpdatePasswordComponentService,
                deps: [UserPasswordFacade, RoutingService, GlobalMessageService, AuthRedirectService, AuthService]
              }]
            }
          }
        }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_PASSWORD) ? myAccountV2PasswordMapping : {})],
        imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, I18nModule, FormErrorsModule, UrlModule, RouterModule, PasswordVisibilityToggleModule, FeaturesConfigModule, MessageComponentModule, BtnLikeLinkModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
      });
    }
  }
  return UpdatePasswordModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UpdateProfileComponentService = /*#__PURE__*/(() => {
  class UpdateProfileComponentService {
    constructor(userProfile, globalMessageService) {
      this.userProfile = userProfile;
      this.globalMessageService = globalMessageService;
      this.user$ = this.userProfile.get().pipe(filter(user => Boolean(user)));
      this.busy$ = new BehaviorSubject(false);
      this.updateSucceed$ = new Subject();
      this.isUpdating$ = this.user$.pipe(tap(user => this.form.patchValue(user)), switchMap(_user => this.busy$), tap(state => state === true ? this.form.disable() : this.form.enable()));
      this.titles$ = this.userProfile.getTitles();
      this.form = new UntypedFormGroup({
        customerId: new UntypedFormControl(''),
        titleCode: new UntypedFormControl(''),
        firstName: new UntypedFormControl('', Validators.required),
        lastName: new UntypedFormControl('', Validators.required)
      });
    }
    /**
     * Updates the user's details and handles the UI.
     */
    updateProfile() {
      if (!this.form.valid) {
        this.form.markAllAsTouched();
        return;
      }
      this.busy$.next(true);
      this.userProfile.update(this.form.value).subscribe({
        next: () => this.onSuccess(),
        error: error => this.onError(error)
      });
    }
    onSuccess() {
      this.globalMessageService.add({
        key: 'updateProfileForm.profileUpdateSuccess'
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      this.busy$.next(false);
      this.form.reset();
      this.updateSucceed$.next(true);
    }
    onError(_error) {
      this.busy$.next(false);
      this.updateSucceed$.next(false);
    }
    static {
      this.ɵfac = function UpdateProfileComponentService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UpdateProfileComponentService)(i0.ɵɵinject(i1.UserProfileFacade), i0.ɵɵinject(i2.GlobalMessageService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UpdateProfileComponentService,
        factory: UpdateProfileComponentService.ɵfac
      });
    }
  }
  return UpdateProfileComponentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UpdateProfileComponent = /*#__PURE__*/(() => {
  class UpdateProfileComponent {
    constructor(service) {
      this.service = service;
      this.routingService = inject(RoutingService, {
        optional: true
      });
      this.form = this.service.form;
      this.isUpdating$ = this.service.isUpdating$;
      this.titles$ = this.service.titles$;
    }
    onSubmit() {
      this.service.updateProfile();
    }
    navigateTo(cxRoute) {
      this.routingService?.go({
        cxRoute
      });
    }
    static {
      this.ɵfac = function UpdateProfileComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UpdateProfileComponent)(i0.ɵɵdirectiveInject(UpdateProfileComponentService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: UpdateProfileComponent,
        selectors: [["cx-update-profile"]],
        hostAttrs: [1, "user-form"],
        standalone: false,
        decls: 42,
        vars: 50,
        consts: [["class", "overlay", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [1, "label-content"], ["formControlName", "titleCode", "id", "title-select", 3, "clearable", "searchable", "cxNgSelectA11y"], [3, "value", 4, "ngFor", "ngForOf"], ["required", "true", "type", "text", "name", "firstName", "formControlName", "firstName", 1, "form-control", 3, "placeholder"], ["id", "firstNameError", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "text", "name", "lastName", "formControlName", "lastName", 1, "form-control", 3, "placeholder"], ["id", "lastNameError", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "text", "name", "customerId", "formControlName", "customerId", "readonly", "", 1, "form-control"], ["id", "customerIdError", 3, "translationParams", "control", 4, "cxFeature"], [4, "cxFeature"], [1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "overlay"], [3, "value"], ["id", "firstNameError", 3, "translationParams", "control"], [3, "control"], ["id", "lastNameError", 3, "translationParams", "control"], ["id", "customerIdError", 3, "translationParams", "control"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], ["cxBtnLikeLink", "", 1, "btn", "btn-block", "btn-secondary", 3, "routerLink"]],
        template: function UpdateProfileComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, UpdateProfileComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelement(2, "cx-form-required-legend");
            i0.ɵɵelementStart(3, "form", 1);
            i0.ɵɵlistener("ngSubmit", function UpdateProfileComponent_Template_form_ngSubmit_3_listener() {
              return ctx.onSubmit();
            });
            i0.ɵɵelementStart(4, "label")(5, "span", 2);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "ng-select", 3);
            i0.ɵɵpipe(9, "cxTranslate");
            i0.ɵɵtemplate(10, UpdateProfileComponent_ng_option_10_Template, 2, 2, "ng-option", 4);
            i0.ɵɵpipe(11, "async");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "label")(13, "span", 2);
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "cxTranslate");
            i0.ɵɵelement(16, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(17, "input", 5);
            i0.ɵɵpipe(18, "cxTranslate");
            i0.ɵɵtemplate(19, UpdateProfileComponent_cx_form_errors_19_Template, 2, 6, "cx-form-errors", 6)(20, UpdateProfileComponent_cx_form_errors_20_Template, 1, 1, "cx-form-errors", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "label")(22, "span", 2);
            i0.ɵɵtext(23);
            i0.ɵɵpipe(24, "cxTranslate");
            i0.ɵɵelement(25, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(26, "input", 8);
            i0.ɵɵpipe(27, "cxTranslate");
            i0.ɵɵtemplate(28, UpdateProfileComponent_cx_form_errors_28_Template, 2, 6, "cx-form-errors", 9)(29, UpdateProfileComponent_cx_form_errors_29_Template, 1, 1, "cx-form-errors", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(30, "label")(31, "span", 2);
            i0.ɵɵtext(32);
            i0.ɵɵpipe(33, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(34, "input", 10);
            i0.ɵɵtemplate(35, UpdateProfileComponent_cx_form_errors_35_Template, 2, 6, "cx-form-errors", 11)(36, UpdateProfileComponent_cx_form_errors_36_Template, 1, 1, "cx-form-errors", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(37, UpdateProfileComponent_ng_container_37_Template, 4, 3, "ng-container", 12)(38, UpdateProfileComponent_ng_container_38_Template, 5, 7, "ng-container", 12);
            i0.ɵɵelementStart(39, "button", 13);
            i0.ɵɵtext(40);
            i0.ɵɵpipe(41, "cxTranslate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_9_0;
            let tmp_15_0;
            let tmp_20_0;
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 28, ctx.isUpdating$));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 30, "updateProfileForm.title"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("clearable", false)("searchable", false)("cxNgSelectA11y", i0.ɵɵpureFunction1(48, _c6, i0.ɵɵpipeBind1(9, 32, "updateProfileForm.title")));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(11, 34, ctx.titles$));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(15, 36, "updateProfileForm.firstName.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(18, 38, "updateProfileForm.firstName.placeholder"));
            i0.ɵɵattribute("aria-invalid", ((tmp_9_0 = ctx.form.get("firstName")) == null ? null : tmp_9_0.touched) && ((tmp_9_0 = ctx.form.get("firstName")) == null ? null : tmp_9_0.invalid))("aria-errormessage", "firstNameError");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(24, 40, "updateProfileForm.lastName.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(27, 42, "updateProfileForm.lastName.placeholder"));
            i0.ɵɵattribute("aria-invalid", ((tmp_15_0 = ctx.form.get("lastName")) == null ? null : tmp_15_0.touched) && ((tmp_15_0 = ctx.form.get("lastName")) == null ? null : tmp_15_0.invalid))("aria-errormessage", "lastNameError");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(33, 44, "updateProfileForm.customerId"));
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("aria-invalid", ((tmp_20_0 = ctx.form.get("customerId")) == null ? null : tmp_20_0.touched) && ((tmp_20_0 = ctx.form.get("customerId")) == null ? null : tmp_20_0.invalid))("aria-errormessage", "customerIdError");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "a11yUseButtonsForBtnLinks");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!a11yUseButtonsForBtnLinks");
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.form.disabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(41, 46, "common.save"), " ");
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.SpinnerComponent, i4.FormErrorsComponent, i5.RouterLink, i6.NgSelectComponent, i6.NgOptionComponent, i4.NgSelectA11yDirective, i2.FeatureDirective, i4.BtnLikeLinkDirective, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i2$1.AsyncPipe, i2.TranslatePipe, i2.UrlPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return UpdateProfileComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let MyAccountV2ProfileComponent = /*#__PURE__*/(() => {
  class MyAccountV2ProfileComponent {
    constructor() {
      this.service = inject(UpdateProfileComponentService);
      this.form = this.service.form;
      this.isUpdating$ = this.service.isUpdating$;
      this.titles$ = this.service.titles$;
      this.user$ = this.service.user$;
    }
    ngOnInit() {
      this.isEditing = false;
    }
    onSubmit() {
      this.service.updateProfile();
      this.service.updateSucceed$.subscribe(res => {
        this.isEditing = !res;
      });
    }
    cancelEdit() {
      this.isEditing = false;
      this.form.setValue(this.originalEditValue);
    }
    onEdit() {
      this.isEditing = true;
      this.originalEditValue = this.form.value;
    }
    static {
      this.ɵfac = function MyAccountV2ProfileComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MyAccountV2ProfileComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MyAccountV2ProfileComponent,
        selectors: [["cx-my-account-v2-profile"]],
        standalone: false,
        decls: 12,
        vars: 11,
        consts: [["class", "overlay", 4, "ngIf"], [1, "flex-line"], [1, "headertext"], ["class", "editButton", 3, "click", 4, "ngIf"], [4, "ngIf"], ["class", "myaccount-editing-area", 4, "ngIf"], [1, "overlay"], [1, "editButton", 3, "click"], [1, "text-head"], [1, "value"], [1, "myaccount-editing-area"], [3, "ngSubmit", "formGroup"], [1, "label-content,", "text-head"], ["formControlName", "titleCode", "id", "title-select", 3, "clearable", "searchable", "cxNgSelectA11y"], [3, "value", 4, "ngFor", "ngForOf"], ["required", "true", "type", "text", "name", "firstName", "formControlName", "firstName", 1, "form-control"], ["id", "firstNameError", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "text", "name", "lastName", "formControlName", "lastName", 1, "form-control"], ["id", "lastNameError", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "text", "name", "customerId", "formControlName", "customerId", "readonly", "", 1, "form-control"], ["id", "customerIdError", 3, "translationParams", "control", 4, "cxFeature"], [1, "btn-group"], [1, "btn", "button-cancel", "button", 3, "click"], [1, "btn", "btn-primary", "button", 3, "click", "disabled"], [3, "value"], ["id", "firstNameError", 3, "translationParams", "control"], [3, "control"], ["id", "lastNameError", 3, "translationParams", "control"], ["id", "customerIdError", 3, "translationParams", "control"]],
        template: function MyAccountV2ProfileComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MyAccountV2ProfileComponent_cx_spinner_0_Template, 1, 0, "cx-spinner", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelementStart(3, "div")(4, "div")(5, "div", 1)(6, "label", 2);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, MyAccountV2ProfileComponent_button_9_Template, 3, 3, "button", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(10, MyAccountV2ProfileComponent_div_10_Template, 23, 21, "div", 4)(11, MyAccountV2ProfileComponent_div_11_Template, 38, 42, "div", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 5, ctx.isUpdating$) || !i0.ɵɵpipeBind1(2, 7, ctx.user$));
            i0.ɵɵadvance(7);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(8, 9, "myAccountV2UserProfile.myInformation"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.isEditing);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isEditing);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isEditing);
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i4.SpinnerComponent, i4.FormErrorsComponent, i6.NgSelectComponent, i6.NgOptionComponent, i4.NgSelectA11yDirective, i2.FeatureDirective, i2$1.AsyncPipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MyAccountV2ProfileComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const USE_MY_ACCOUNT_V2_PROFILE = new InjectionToken('feature flag to enable enhanced UI for profile related pages under My-Account', {
  providedIn: 'root',
  factory: () => false
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const myAccountV2ProfileMapping = {
  cmsComponents: {
    UpdateProfileComponent: {
      component: MyAccountV2ProfileComponent
    }
  }
};
let UpdateProfileModule = /*#__PURE__*/(() => {
  class UpdateProfileModule {
    static {
      this.ɵfac = function UpdateProfileModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UpdateProfileModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: UpdateProfileModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            UpdateProfileComponent: {
              component: UpdateProfileComponent,
              guards: [AuthGuard],
              providers: [{
                provide: UpdateProfileComponentService,
                useClass: UpdateProfileComponentService,
                deps: [UserProfileFacade, GlobalMessageService]
              }]
            }
          }
        }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_PROFILE) ? myAccountV2ProfileMapping : {})],
        imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, I18nModule, FormErrorsModule, RouterModule, UrlModule, NgSelectModule, NgSelectA11yModule, FeaturesConfigModule, BtnLikeLinkModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
      });
    }
  }
  return UpdateProfileModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let AddressBookComponentService = /*#__PURE__*/(() => {
  class AddressBookComponentService {
    constructor(userAddressService) {
      this.userAddressService = userAddressService;
    }
    getAddresses() {
      return this.userAddressService.getAddresses();
    }
    getAddressesStateLoading() {
      return this.userAddressService.getAddressesLoading();
    }
    loadAddresses() {
      this.userAddressService.loadAddresses();
    }
    addUserAddress(address) {
      this.userAddressService.addUserAddress(address);
    }
    updateUserAddress(addressId, address) {
      this.userAddressService.updateUserAddress(addressId, address);
    }
    setAddressAsDefault(addressId) {
      this.userAddressService.setAddressAsDefault(addressId);
    }
    deleteUserAddress(addressId) {
      this.userAddressService.deleteUserAddress(addressId);
    }
    static {
      this.ɵfac = function AddressBookComponentService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddressBookComponentService)(i0.ɵɵinject(i2.UserAddressService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AddressBookComponentService,
        factory: AddressBookComponentService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AddressBookComponentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let AddressFormComponent = /*#__PURE__*/(() => {
  class AddressFormComponent {
    constructor(fb, userAddressService, globalMessageService, translation, launchDialogService, userProfileFacade) {
      this.fb = fb;
      this.userAddressService = userAddressService;
      this.globalMessageService = globalMessageService;
      this.translation = translation;
      this.launchDialogService = launchDialogService;
      this.userProfileFacade = userProfileFacade;
      this.selectedCountry$ = new BehaviorSubject('');
      this.setAsDefaultField = true;
      this.showCancelBtn = true;
      this.submitAddress = new EventEmitter();
      this.backToAddress = new EventEmitter();
      this.subscription = new Subscription();
      this.addressForm = this.fb.group({
        country: this.fb.group({
          isocode: [null, Validators.required]
        }),
        titleCode: [''],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        line1: ['', Validators.required],
        line2: [''],
        town: ['', Validators.required],
        region: this.fb.group({
          isocode: [null, Validators.required]
        }),
        postalCode: ['', Validators.required],
        phone: '',
        cellphone: '',
        defaultAddress: [false]
      });
    }
    ngOnInit() {
      // Fetching countries if no data stream was provided
      this.countries$ = this.countries || this.userAddressService.getDeliveryCountries().pipe(tap(countries => {
        if (Object.keys(countries).length === 0) {
          this.userAddressService.loadDeliveryCountries();
        }
      }));
      // Fetching titles
      this.titles$ = this.getTitles();
      // Fetching regions
      this.regions$ = this.selectedCountry$.pipe(switchMap(country => this.userAddressService.getRegions(country)), tap(regions => {
        const regionControl = this.addressForm.get('region.isocode');
        if (regions && regions.length > 0) {
          regionControl?.enable();
        } else {
          regionControl?.disable();
        }
      }));
      if (this.addressData && Object.keys(this.addressData).length !== 0) {
        this.addressForm.patchValue(this.addressData);
        this.countrySelected(this.addressData.country);
        if (this.addressData.region) {
          this.regionSelected(this.addressData.region);
        }
      }
      this.addresses$ = this.userAddressService.getAddresses();
    }
    getTitles() {
      return combineLatest([this.translation.translate('addressForm.defaultTitle'), this.userProfileFacade.getTitles()]).pipe(map(([noneTitleText, titles]) => {
        const noneTitle = {
          code: '',
          name: noneTitleText
        };
        titles.sort(sortTitles);
        return [noneTitle, ...titles];
      }));
    }
    handleAddressVerificationResults(results) {
      if (results.decision === 'ACCEPT') {
        this.submitAddress.emit(this.addressForm.value);
      } else if (results.decision === 'REJECT') {
        // TODO: Workaround: allow server for decide is titleCode mandatory (if yes, provide personalized message)
        if (results.errors?.errors.some(error => error.subject === 'titleCode')) {
          this.globalMessageService.add({
            key: 'addressForm.titleRequired'
          }, GlobalMessageType.MSG_TYPE_ERROR);
        } else {
          this.globalMessageService.add({
            key: 'addressForm.invalidAddress'
          }, GlobalMessageType.MSG_TYPE_ERROR);
        }
      } else if (results.decision === 'REVIEW') {
        this.openSuggestedAddress(results);
      }
    }
    countrySelected(country) {
      this.addressForm.get('country')?.get('isocode')?.setValue(country?.isocode);
      this.selectedCountry$.next(country?.isocode ?? '');
    }
    regionSelected(region) {
      this.addressForm.get('region')?.get('isocode')?.setValue(region.isocode);
    }
    toggleDefaultAddress() {
      this.addressForm['controls'].defaultAddress.setValue(this.addressForm.value.defaultAddress);
    }
    back() {
      this.backToAddress.emit();
    }
    verifyAddress() {
      if (this.addressForm.valid) {
        const regionControl = this.addressForm.get('region');
        const isocode = regionControl?.value?.isocode;
        if (isocode) {
          this.regions$.pipe(take(1)).subscribe(regions => {
            if (regions.length) {
              const selectedRegion = regions.find(region => region.isocode === isocode);
              regionControl?.patchValue({
                isocodeShort: selectedRegion?.isocodeShort
              });
            } else {
              regionControl?.reset();
            }
          });
        }
        if (this.addressForm.dirty) {
          this.subscription.add(this.userAddressService.verifyAddress(this.addressForm.value).subscribe(value => {
            this.handleAddressVerificationResults(value);
          }));
        } else {
          // address form value not changed
          // ignore duplicate address
          this.submitAddress.emit(undefined);
        }
      } else {
        this.addressForm.markAllAsTouched();
        this.globalMessageService.add({
          key: 'formErrors.globalMessage'
        }, GlobalMessageType.MSG_TYPE_ASSISTIVE);
      }
    }
    openSuggestedAddress(results) {
      this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.SUGGESTED_ADDRESSES, this.element, {
        enteredAddress: this.addressForm.value,
        suggestedAddresses: results.suggestedAddresses
      });
      this.subscription.add(this.launchDialogService.dialogClose.pipe(filter(result => Boolean(result))).subscribe(result => {
        if (typeof result === 'object') {
          const address = {
            ...result,
            titleCode: this.addressForm.value.titleCode,
            phone: this.addressForm.value.phone,
            selected: true
          };
          this.submitAddress.emit(address);
        }
      }));
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static {
      this.ɵfac = function AddressFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddressFormComponent)(i0.ɵɵdirectiveInject(i3.UntypedFormBuilder), i0.ɵɵdirectiveInject(i2.UserAddressService), i0.ɵɵdirectiveInject(i2.GlobalMessageService), i0.ɵɵdirectiveInject(i2.TranslationService), i0.ɵɵdirectiveInject(i4.LaunchDialogService), i0.ɵɵdirectiveInject(i1.UserProfileFacade));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AddressFormComponent,
        selectors: [["cx-address-form"]],
        viewQuery: function AddressFormComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c7, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
          }
        },
        inputs: {
          addressData: "addressData",
          actionBtnLabel: "actionBtnLabel",
          cancelBtnLabel: "cancelBtnLabel",
          setAsDefaultField: "setAsDefaultField",
          showTitleCode: "showTitleCode",
          showCancelBtn: "showCancelBtn",
          countries: "countries"
        },
        outputs: {
          submitAddress: "submitAddress",
          backToAddress: "backToAddress"
        },
        standalone: false,
        decls: 91,
        vars: 83,
        consts: [["submit", ""], [3, "ngSubmit", "formGroup"], ["formGroupName", "country", 1, "form-group"], [4, "ngIf"], ["class", "form-group", 4, "ngIf"], [1, "form-group"], [1, "label-content", "required"], ["required", "true", "type", "text", "formControlName", "firstName", 1, "form-control", 3, "placeholder"], ["id", "firstNameError", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "text", "formControlName", "lastName", 1, "form-control", 3, "placeholder"], ["id", "lastNameError", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "text", "formControlName", "line1", 1, "form-control", 3, "placeholder"], ["id", "line1Error", 3, "translationParams", "control", 4, "cxFeature"], [1, "label-content"], ["type", "text", "formControlName", "line2", 1, "form-control", 3, "placeholder"], [1, "row"], [1, "form-group", "col-sm-6"], ["required", "true", "type", "text", "formControlName", "town", 1, "form-control", 3, "placeholder"], ["id", "townError", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "text", "formControlName", "postalCode", 1, "form-control", 3, "placeholder"], ["id", "postalCodeError", 3, "translationParams", "control", 4, "cxFeature"], ["formGroupName", "region", 4, "ngIf"], [1, "form-group", "col-md-6"], ["type", "tel", "formControlName", "phone", 1, "form-control", 3, "placeholder"], ["type", "tel", "formControlName", "cellphone", 1, "form-control", 3, "placeholder"], [1, "cx-address-form-btns"], ["class", "col-md-13 col-lg-6", 4, "ngIf"], [1, "col-md-13", "col-lg-6"], ["type", "submit", 1, "btn", "btn-block", "btn-primary"], ["id", "country-select", "formControlName", "isocode", "bindLabel", "name", "bindValue", "isocode", 1, "country-select", 3, "change", "inputAttrs", "searchable", "clearable", "items", "placeholder", "cxNgSelectA11y"], [3, "translationParams", "control", 4, "cxFeature"], [3, "translationParams", "control"], [3, "control"], ["id", "title-select", "formControlName", "titleCode", "bindLabel", "name", "bindValue", "code", 3, "searchable", "clearable", "items", "placeholder", "cxNgSelectA11y"], ["id", "firstNameError", 3, "translationParams", "control"], ["id", "lastNameError", 3, "translationParams", "control"], ["id", "line1Error", 3, "translationParams", "control"], ["id", "townError", 3, "translationParams", "control"], ["id", "postalCodeError", 3, "translationParams", "control"], ["formGroupName", "region"], ["formControlName", "isocode", "id", "region-select", 1, "region-select", 3, "inputAttrs", "searchable", "clearable", "items", "bindLabel", "bindValue", "placeholder", "cxNgSelectA11y"], [1, "form-check"], ["type", "checkbox", "formControlName", "defaultAddress", 1, "form-check-input", 3, "change"], [1, "form-check-label"], [1, "btn", "btn-block", "btn-secondary", 3, "click"]],
        template: function AddressFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelement(0, "cx-form-required-legend");
            i0.ɵɵelementStart(1, "form", 1);
            i0.ɵɵlistener("ngSubmit", function AddressFormComponent_Template_form_ngSubmit_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.verifyAddress());
            });
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, AddressFormComponent_ng_container_3_Template, 2, 1, "ng-container", 3);
            i0.ɵɵpipe(4, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, AddressFormComponent_div_5_Template, 3, 3, "div", 4);
            i0.ɵɵelementStart(6, "div", 5)(7, "label")(8, "span", 6);
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "cxTranslate");
            i0.ɵɵelement(11, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(12, "input", 7);
            i0.ɵɵpipe(13, "cxTranslate");
            i0.ɵɵtemplate(14, AddressFormComponent_cx_form_errors_14_Template, 2, 6, "cx-form-errors", 8)(15, AddressFormComponent_cx_form_errors_15_Template, 1, 1, "cx-form-errors", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "div", 5)(17, "label")(18, "span", 6);
            i0.ɵɵtext(19);
            i0.ɵɵpipe(20, "cxTranslate");
            i0.ɵɵelement(21, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(22, "input", 10);
            i0.ɵɵpipe(23, "cxTranslate");
            i0.ɵɵtemplate(24, AddressFormComponent_cx_form_errors_24_Template, 2, 6, "cx-form-errors", 11)(25, AddressFormComponent_cx_form_errors_25_Template, 1, 1, "cx-form-errors", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(26, "div", 5)(27, "label")(28, "span", 6);
            i0.ɵɵtext(29);
            i0.ɵɵpipe(30, "cxTranslate");
            i0.ɵɵelement(31, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(32, "input", 12);
            i0.ɵɵpipe(33, "cxTranslate");
            i0.ɵɵtemplate(34, AddressFormComponent_cx_form_errors_34_Template, 2, 6, "cx-form-errors", 13)(35, AddressFormComponent_cx_form_errors_35_Template, 1, 1, "cx-form-errors", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(36, "div", 5)(37, "label")(38, "span", 14);
            i0.ɵɵtext(39);
            i0.ɵɵpipe(40, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(41, "input", 15);
            i0.ɵɵpipe(42, "cxTranslate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(43, "div", 16)(44, "div", 17)(45, "label")(46, "span", 6);
            i0.ɵɵtext(47);
            i0.ɵɵpipe(48, "cxTranslate");
            i0.ɵɵelement(49, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(50, "input", 18);
            i0.ɵɵpipe(51, "cxTranslate");
            i0.ɵɵtemplate(52, AddressFormComponent_cx_form_errors_52_Template, 2, 6, "cx-form-errors", 19)(53, AddressFormComponent_cx_form_errors_53_Template, 1, 1, "cx-form-errors", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(54, "div", 17)(55, "label")(56, "span", 6);
            i0.ɵɵtext(57);
            i0.ɵɵpipe(58, "cxTranslate");
            i0.ɵɵelement(59, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(60, "input", 20);
            i0.ɵɵpipe(61, "cxTranslate");
            i0.ɵɵtemplate(62, AddressFormComponent_cx_form_errors_62_Template, 2, 6, "cx-form-errors", 21)(63, AddressFormComponent_cx_form_errors_63_Template, 1, 1, "cx-form-errors", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(64, AddressFormComponent_ng_container_64_Template, 2, 1, "ng-container", 22);
            i0.ɵɵpipe(65, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(66, "div", 16)(67, "div", 23)(68, "label")(69, "span", 14);
            i0.ɵɵtext(70);
            i0.ɵɵpipe(71, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(72, "input", 24);
            i0.ɵɵpipe(73, "cxTranslate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(74, "div", 23)(75, "label")(76, "span", 14);
            i0.ɵɵtext(77);
            i0.ɵɵpipe(78, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(79, "input", 25);
            i0.ɵɵpipe(80, "cxTranslate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(81, AddressFormComponent_div_81_Template, 7, 3, "div", 4);
            i0.ɵɵpipe(82, "async");
            i0.ɵɵelementStart(83, "div", 26)(84, "div", 16);
            i0.ɵɵtemplate(85, AddressFormComponent_div_85_Template, 4, 3, "div", 27);
            i0.ɵɵelementStart(86, "div", 28)(87, "button", 29, 0);
            i0.ɵɵtext(89);
            i0.ɵɵpipe(90, "cxTranslate");
            i0.ɵɵelementEnd()()()()();
          }
          if (rf & 2) {
            let tmp_6_0;
            let tmp_12_0;
            let tmp_18_0;
            let tmp_26_0;
            let tmp_32_0;
            let tmp_41_0;
            i0.ɵɵadvance();
            i0.ɵɵproperty("formGroup", ctx.addressForm);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 43, ctx.countries$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showTitleCode);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(10, 45, "addressForm.firstName.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(13, 47, "addressForm.firstName.placeholder"));
            i0.ɵɵattribute("aria-invalid", ((tmp_6_0 = ctx.addressForm.get("firstName")) == null ? null : tmp_6_0.touched) && ((tmp_6_0 = ctx.addressForm.get("firstName")) == null ? null : tmp_6_0.invalid))("aria-errormessage", "firstNameError");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(20, 49, "addressForm.lastName.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(23, 51, "addressForm.lastName.placeholder"));
            i0.ɵɵattribute("aria-invalid", ((tmp_12_0 = ctx.addressForm.get("lastName")) == null ? null : tmp_12_0.touched) && ((tmp_12_0 = ctx.addressForm.get("lastName")) == null ? null : tmp_12_0.invalid))("aria-errormessage", "lastNameError");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(30, 53, "addressForm.address1"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(33, 55, "addressForm.streetAddress"));
            i0.ɵɵattribute("aria-invalid", ((tmp_18_0 = ctx.addressForm.get("line1")) == null ? null : tmp_18_0.touched) && ((tmp_18_0 = ctx.addressForm.get("line1")) == null ? null : tmp_18_0.invalid))("aria-errormessage", "line1Error");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(40, 57, "addressForm.address2"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(42, 59, "addressForm.aptSuite"));
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(48, 61, "addressForm.city.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(51, 63, "addressForm.city.placeholder"));
            i0.ɵɵattribute("aria-invalid", ((tmp_26_0 = ctx.addressForm.get("town")) == null ? null : tmp_26_0.touched) && ((tmp_26_0 = ctx.addressForm.get("town")) == null ? null : tmp_26_0.invalid))("aria-errormessage", "townError");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(58, 65, "addressForm.zipCode.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(61, 67, "addressForm.zipCode.placeholder"));
            i0.ɵɵattribute("aria-invalid", ((tmp_32_0 = ctx.addressForm.get("postalCode")) == null ? null : tmp_32_0.touched) && ((tmp_32_0 = ctx.addressForm.get("postalCode")) == null ? null : tmp_32_0.invalid))("aria-errormessage", "postalCodeError");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(65, 69, ctx.regions$));
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(71, 71, "addressForm.phoneNumber.label"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(73, 73, "addressForm.phoneNumber.placeholder"));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(78, 75, "addressForm.cellphone.label"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(80, 77, "addressForm.cellphone.placeholder"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ((tmp_41_0 = i0.ɵɵpipeBind1(82, 79, ctx.addresses$)) == null ? null : tmp_41_0.length) && ctx.setAsDefaultField);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.showCancelBtn);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", ctx.actionBtnLabel || i0.ɵɵpipeBind1(90, 81, "common.continue"), " ");
          }
        },
        dependencies: [i4.NgSelectA11yDirective, i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i3.FormGroupName, i6.NgSelectComponent, i4.FormErrorsComponent, i2.FeatureDirective, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i2$1.AsyncPipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return AddressFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let AddressBookComponent = /*#__PURE__*/(() => {
  class AddressBookComponent {
    constructor(service, translation, globalMessageService) {
      this.service = service;
      this.translation = translation;
      this.globalMessageService = globalMessageService;
      this.showAddAddressForm = false;
      this.showEditAddressForm = false;
    }
    ngOnInit() {
      this.addresses$ = this.service.getAddresses();
      this.addressesStateLoading$ = this.service.getAddressesStateLoading();
      this.service.loadAddresses();
    }
    addAddressButtonHandle() {
      this.showEditAddressForm = false;
      this.showAddAddressForm = true;
    }
    editAddressButtonHandle(address) {
      this.showAddAddressForm = false;
      this.showEditAddressForm = true;
      this.currentAddress = address;
    }
    addAddressSubmit(address) {
      this.showAddAddressForm = false;
      this.service.addUserAddress(address);
    }
    addAddressCancel() {
      this.showAddAddressForm = false;
    }
    editAddressSubmit(address) {
      this.showEditAddressForm = false;
      if (address && this.currentAddress['id']) {
        this.service.updateUserAddress(this.currentAddress['id'], address);
      }
    }
    editAddressCancel() {
      this.showEditAddressForm = false;
    }
    getCardContent(address) {
      return combineLatest([this.translation.translate('addressCard.default'), this.translation.translate('addressCard.setAsDefault'), this.translation.translate('common.delete'), this.translation.translate('common.edit'), this.translation.translate('addressBook.areYouSureToDeleteAddress'), this.translation.translate('addressCard.phoneNumber'), this.translation.translate('addressCard.mobileNumber')]).pipe(map(([defaultText, setAsDefaultText, textDelete, textEdit, textVerifyDeleteMsg, textPhone, textMobile]) => {
        let region = '';
        if (address.region && address.region.isocode) {
          region = address.region.isocode + ', ';
        }
        const actions = [];
        if (!address.defaultAddress) {
          actions.push({
            name: setAsDefaultText,
            event: 'default'
          });
        }
        actions.push({
          name: textEdit,
          event: 'edit'
        });
        actions.push({
          name: textDelete,
          event: 'delete'
        });
        const numbers = getAddressNumbers(address, textPhone, textMobile);
        return {
          role: 'application',
          textBold: address.firstName + ' ' + address.lastName,
          text: [address.line1, address.line2, address.town + ', ' + region + address.country?.isocode, address.postalCode, numbers],
          actions: actions,
          header: address.defaultAddress ? `✓ ${defaultText}` : '',
          deleteMsg: textVerifyDeleteMsg,
          label: address.defaultAddress ? 'addressBook.defaultDeliveryAddress' : 'addressBook.additionalDeliveryAddress'
        };
      }));
    }
    setAddressAsDefault(address) {
      this.service.setAddressAsDefault(address.id ?? '');
      this.globalMessageService.add({
        key: 'addressMessages.setAsDefaultSuccessfully',
        params: {
          streetAddress: address.line1
        }
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
    deleteAddress(addressId) {
      this.service.deleteUserAddress(addressId);
    }
    setEdit(addressId) {
      if (this.editCard !== addressId) {
        this.editCard = addressId;
      } else {
        this.deleteAddress(addressId);
      }
    }
    cancelCard() {
      this.editCard = null;
    }
    static {
      this.ɵfac = function AddressBookComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddressBookComponent)(i0.ɵɵdirectiveInject(AddressBookComponentService), i0.ɵɵdirectiveInject(i2.TranslationService), i0.ɵɵdirectiveInject(i2.GlobalMessageService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AddressBookComponent,
        selectors: [["cx-address-book"]],
        standalone: false,
        decls: 8,
        vars: 7,
        consts: [["loading", ""], [1, "cx-section"], [4, "ngIf"], [1, "row"], [1, "col-md-6"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], ["class", "row cx-address-deck", 4, "ngIf", "ngIfElse"], [1, "row", "cx-address-deck"], ["role", "status", 4, "cxFeature"], ["class", "col-md-6 cx-address-card", 4, "ngFor", "ngForOf"], ["role", "status"], [1, "col-md-6", "cx-address-card"], [3, "editCard", "setDefaultCard", "deleteCard", "cancelCard", "index", "border", "fitToContainer", "content", "editMode"], [1, "cx-section-msg"], [1, "cx-form", 3, "submitAddress", "backToAddress", "cancelCard", "showTitleCode", "showCancelBtn", "actionBtnLabel", "cancelBtnLabel", "setAsDefaultField"], [3, "submitAddress", "backToAddress", "showTitleCode", "actionBtnLabel", "cancelBtnLabel", "addressData"], [1, "col-md-12", "cx-address-spinner"]],
        template: function AddressBookComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, AddressBookComponent_ng_container_1_Template, 8, 7, "ng-container", 2);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵtemplate(3, AddressBookComponent_ng_container_3_Template, 10, 16, "ng-container", 2);
            i0.ɵɵpipe(4, "async");
            i0.ɵɵtemplate(5, AddressBookComponent_ng_container_5_Template, 8, 11, "ng-container", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, AddressBookComponent_ng_template_6_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            let tmp_1_0;
            let tmp_2_0;
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ((tmp_1_0 = i0.ɵɵpipeBind1(2, 3, ctx.addresses$)) == null ? null : tmp_1_0.length) && !(ctx.showAddAddressForm || ctx.showEditAddressForm));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", (!((tmp_2_0 = i0.ɵɵpipeBind1(4, 5, ctx.addresses$)) == null ? null : tmp_2_0.length) || ctx.showAddAddressForm) && !ctx.showEditAddressForm);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showEditAddressForm);
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i4.CardComponent, AddressFormComponent, i4.SpinnerComponent, i2.FeatureDirective, i2$1.AsyncPipe, i2.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return AddressBookComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let SuggestedAddressDialogComponent = /*#__PURE__*/(() => {
  class SuggestedAddressDialogComponent {
    handleClick(event) {
      if (event.target.tagName === this.el.nativeElement.tagName) {
        this.closeModal('Cross click');
      }
    }
    constructor(launchDialogService, el) {
      this.launchDialogService = launchDialogService;
      this.el = el;
      this.iconTypes = ICON_TYPE;
      this.focusConfig = {
        trap: true,
        block: true,
        autofocus: 'button',
        focusOnEscape: true
      };
      this.data$ = this.launchDialogService.data$;
    }
    ngOnInit() {
      this.data$.pipe(take(1)).subscribe(data => this.setSelectedAddress(data));
    }
    closeModal(reason) {
      this.launchDialogService.closeDialog(reason);
    }
    setSelectedAddress(data) {
      this.selectedAddress = data.suggestedAddresses?.length ? data.suggestedAddresses[0] : data.enteredAddress;
    }
    static {
      this.ɵfac = function SuggestedAddressDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SuggestedAddressDialogComponent)(i0.ɵɵdirectiveInject(i4.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SuggestedAddressDialogComponent,
        selectors: [["cx-suggested-addresses-dialog"]],
        hostBindings: function SuggestedAddressDialogComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function SuggestedAddressDialogComponent_click_HostBindingHandler($event) {
              return ctx.handleClick($event);
            });
          }
        },
        standalone: false,
        decls: 3,
        vars: 4,
        consts: [["role", "dialog", "aria-labelledby", "dialogTitle", 1, "modal-dialog", "modal-dialog-centered", "modal-lg", "cx-suggested-addresses-dialog", 3, "esc", "cxFocus"], ["class", "modal-content cx-suggested-addresses-container", 4, "ngIf"], [1, "modal-content", "cx-suggested-addresses-container"], [1, "cx-suggested-addresses-header", "cx-modal-header"], ["id", "dialogTitle", "class", "cx-suggested-addresses-title", 4, "cxFeature"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], ["ngForm", "", 1, "modal-body"], [1, "cx-dialog-info"], [1, "cx-dialog-options"], ["class", "form-check", 4, "ngFor", "ngForOf"], [1, "form-check"], ["type", "radio", "name", "selectedAddress", "id", "suggested-addresses--entered", 1, "form-check-input", 3, "ngModelChange", "ngModel", "value"], ["for", "suggested-addresses--entered", 1, "form-check-label", "cx-dialog-label"], [1, "cx-dialog-entered"], [1, "cx-card-container"], [1, "cx-card-label"], [1, "cx-suggested-addresses-footer", "cx-modal-footer"], [1, "row"], [1, "cx-dialog-actions", "col-sm-12", "col-md-12", "col-lg-6", "offset-lg-6"], [1, "btn", "btn-secondary", "cx-dialog-buttons", 3, "click"], ["cxAutoFocus", "", 1, "btn", "btn-primary", "cx-dialog-buttons", 3, "click"], ["id", "dialogTitle", 1, "cx-suggested-addresses-title"], ["type", "radio", "name", "selectedAddress", 1, "form-check-input", 3, "ngModelChange", "ngModel", "value", "id"], [1, "form-check-label", "cx-dialog-label", 3, "for"], [1, "cx-dialog-suggested"]],
        template: function SuggestedAddressDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("esc", function SuggestedAddressDialogComponent_Template_div_esc_0_listener() {
              return ctx.closeModal("Escape clicked");
            });
            i0.ɵɵtemplate(1, SuggestedAddressDialogComponent_div_1_Template, 44, 34, "div", 1);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("cxFocus", ctx.focusConfig);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx.data$));
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i3.DefaultValueAccessor, i3.RadioControlValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.NgModel, i3.NgForm, i4.IconComponent, i4.FocusDirective, i2.FeatureDirective, i2$1.AsyncPipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return SuggestedAddressDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let AddressFormModule = /*#__PURE__*/(() => {
  class AddressFormModule {
    static {
      this.ɵfac = function AddressFormModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddressFormModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AddressFormModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [NgSelectA11yModule, CommonModule, ReactiveFormsModule, FormsModule, RouterModule, NgSelectModule, IconModule, I18nModule, FormErrorsModule, KeyboardFocusModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
      });
    }
  }
  return AddressFormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultSuggestedAddressesDialogLayoutConfig = {
  launch: {
    SUGGESTED_ADDRESSES: {
      inlineRoot: true,
      component: SuggestedAddressDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let AddressBookModule = /*#__PURE__*/(() => {
  class AddressBookModule {
    static {
      this.ɵfac = function AddressBookModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddressBookModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AddressBookModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            AccountAddressBookComponent: {
              component: AddressBookComponent,
              guards: [AuthGuard]
            }
          }
        }), provideDefaultConfig(defaultSuggestedAddressesDialogLayoutConfig), UserAddressService],
        imports: [CommonModule, CardModule, AddressFormModule, SpinnerModule, I18nModule, FeaturesConfigModule]
      });
    }
  }
  return AddressBookModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const ONE_TIME_PASSWORD_REGISTRATION_PURPOSE = 'REGISTRATION';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let OneTimePasswordRegisterComponent = /*#__PURE__*/(() => {
  class OneTimePasswordRegisterComponent {
    get additionalConsents() {
      return this.registerForm?.get('additionalConsents');
    }
    updateAdditionalConsents(event, index) {
      const {
        checked
      } = event.target;
      this.registerForm.value.additionalConsents[index] = checked;
    }
    constructor() {
      this.globalMessageService = inject(GlobalMessageService);
      this.fb = inject(UntypedFormBuilder);
      this.router = inject(RoutingService);
      this.anonymousConsentsService = inject(AnonymousConsentsService);
      this.anonymousConsentsConfig = inject(AnonymousConsentsConfig);
      this.clientAuthenticationTokenService = inject(ClientAuthenticationTokenService);
      this.registerComponentService = inject(RegisterComponentService);
      this.routingService = inject(RoutingService);
      this.registrationVerificationTokenFacade = inject(VerificationTokenFacade);
      this.isLoading$ = new BehaviorSubject(false);
      this.subscription = new Subscription();
      this.registerForm = this.fb.group({
        titleCode: [null],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        email: ['', [Validators.required, CustomFormValidators.emailValidator]],
        newsletter: new UntypedFormControl({
          value: false,
          disabled: this.isConsentRequired()
        }),
        additionalConsents: this.registerComponentService.generateAdditionalConsentsFormControl?.() ?? this.fb.array([]),
        termsandconditions: [false, Validators.requiredTrue],
        captcha: [false, Validators.requiredTrue]
      });
      useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
    }
    ngOnInit() {
      this.titles$ = this.registerComponentService.getTitles().pipe(map$1(titles => {
        return titles.sort(sortTitles);
      }));
      // TODO: Workaround: allow server for decide is titleCode mandatory (if yes, provide personalized message)
      this.subscription.add(this.globalMessageService.get().pipe(filter$1(messages => !!Object.keys(messages).length)).subscribe(globalMessageEntities => {
        const messages = globalMessageEntities && globalMessageEntities[GlobalMessageType.MSG_TYPE_ERROR];
        if (messages && messages.some(message => message.raw === 'This field is required.')) {
          this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
          this.globalMessageService.add({
            key: 'register.titleRequired'
          }, GlobalMessageType.MSG_TYPE_ERROR);
        }
      }));
      const registerConsent = this.anonymousConsentsConfig?.anonymousConsents?.registerConsent ?? '';
      this.anonymousConsent$ = combineLatest([this.anonymousConsentsService.getConsent(registerConsent), this.anonymousConsentsService.getTemplate(registerConsent)]).pipe(map$1(([consent, template]) => {
        return {
          consent,
          template: template?.description ? template.description : ''
        };
      }));
      this.additionalRegistrationConsents = this.registerComponentService?.getAdditionalConsents() || [];
      this.subscription.add(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.registerForm.get('newsletter')?.valueChanges.subscribe(() => {
        this.toggleAnonymousConsent();
      }));
    }
    submitForm() {
      if (this.registerForm.valid) {
        this.sendRegistrationVerificationToken();
      } else {
        this.registerForm.markAllAsTouched();
      }
    }
    sendRegistrationVerificationToken() {
      this.isLoading$.next(true);
      this.clientAuthenticationTokenService.loadClientAuthenticationToken();
      const registrationVerificationTokenCreation = this.collectDataFromRegisterForm();
      this.registrationVerificationTokenFacade.createVerificationToken(registrationVerificationTokenCreation).subscribe({
        next: result => this.goToVerificationTokenForm(result),
        error: error => {
          this.routingService.go({
            cxRoute: 'verifyTokenForRegistration'
          }, {
            state: {
              errorStatus: error.status,
              titleCode: this.registerForm.value.titleCode,
              firstName: this.registerForm.value.firstName,
              lastName: this.registerForm.value.lastName,
              loginId: this.registerForm.value.email.toLowerCase()
            }
          });
          this.isLoading$.next(false);
        },
        complete: () => this.onCreateRegistrationVerificationTokenComplete()
      });
    }
    onCreateRegistrationVerificationTokenComplete() {
      this.isLoading$.next(false);
    }
    collectDataFromRegisterForm() {
      return {
        loginId: this.registerForm.value.email.toLowerCase(),
        purpose: ONE_TIME_PASSWORD_REGISTRATION_PURPOSE
      };
    }
    goToVerificationTokenForm(registrationVerificationToken) {
      this.routingService.go({
        cxRoute: 'verifyTokenForRegistration'
      }, {
        state: {
          loginId: this.registerForm.value.email.toLowerCase(),
          tokenId: registrationVerificationToken.tokenId,
          expiresIn: registrationVerificationToken.expiresIn,
          titleCode: this.registerForm.value.titleCode,
          firstName: this.registerForm.value.firstName,
          lastName: this.registerForm.value.lastName
        }
      });
    }
    isConsentGiven(consent) {
      return this.anonymousConsentsService.isConsentGiven(consent);
    }
    isConsentRequired() {
      const requiredConsents = this.anonymousConsentsConfig?.anonymousConsents?.requiredConsents;
      const registerConsent = this.anonymousConsentsConfig?.anonymousConsents?.registerConsent;
      if (requiredConsents && registerConsent) {
        return requiredConsents.includes(registerConsent);
      }
      return false;
    }
    toggleAnonymousConsent() {
      const registerConsent = this.anonymousConsentsConfig?.anonymousConsents?.registerConsent;
      if (registerConsent) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (Boolean(this.registerForm.get('newsletter')?.value)) {
          this.anonymousConsentsService.giveConsent(registerConsent);
        } else {
          this.anonymousConsentsService.withdrawConsent(registerConsent);
        }
      }
    }
    /**
     * Triggered via CaptchaComponent when a user confirms captcha
     */
    captchaConfirmed() {
      this.registerForm.get('captcha')?.setValue(true);
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static {
      this.ɵfac = function OneTimePasswordRegisterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OneTimePasswordRegisterComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OneTimePasswordRegisterComponent,
        selectors: [["cx-otp-register-form"]],
        standalone: false,
        decls: 4,
        vars: 4,
        consts: [["loading", ""], ["class", "cx-page-section container", 4, "ngIf", "ngIfElse"], [1, "cx-page-section", "container"], ["role", "status", 4, "cxFeature"], [1, "row", "justify-content-center"], [1, "col-md-6"], [1, "cx-section"], [3, "ngSubmit", "formGroup"], [1, "form-group"], [1, "label-content"], ["bindLabel", "name", "bindValue", "code", "formControlName", "titleCode", "id", "title-select", 3, "clearable", "items", "placeholder", "searchable", "cxNgSelectA11y"], ["required", "true", "type", "text", "name", "firstname", "formControlName", "firstName", 1, "form-control", 3, "placeholder"], [3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "text", "name", "lastname", "formControlName", "lastName", 1, "form-control", 3, "placeholder"], ["required", "true", "type", "email", "name", "email", "formControlName", "email", 1, "form-control", 3, "placeholder"], [1, "form-check"], [4, "ngIf"], ["formArrayName", "additionalConsents", "class", "form-group", 4, "ngIf"], ["required", "true", "type", "checkbox", "name", "termsandconditions", "formControlName", "termsandconditions"], [1, "form-check-label"], ["target", "_blank", "rel", "noopener noreferrer", 3, "routerLink"], [3, "confirmed"], [3, "control"], ["type", "submit", 1, "btn", "btn-block", "btn-primary"], [1, "cx-login-link", "btn-link", 3, "routerLink"], ["role", "status"], [3, "translationParams", "control"], ["type", "checkbox", "name", "newsletter", "formControlName", "newsletter", 1, "form-check-input", 3, "checked"], ["formArrayName", "additionalConsents", 1, "form-group"], ["class", "form-check", 4, "ngFor", "ngForOf"], ["type", "checkbox", 3, "change", "required", "name", "formControlName"], [1, "cx-spinner"]],
        template: function OneTimePasswordRegisterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, OneTimePasswordRegisterComponent_section_0_Template, 72, 66, "section", 1);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, OneTimePasswordRegisterComponent_ng_template_2_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const loading_r10 = i0.ɵɵreference(3);
            i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(1, 2, ctx.isLoading$))("ngIfElse", loading_r10);
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i5.RouterLink, i2.FeatureDirective, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.CheckboxRequiredValidator, i3.FormGroupDirective, i3.FormControlName, i3.FormArrayName, i6.NgSelectComponent, i4.NgSelectA11yDirective, i4.CaptchaComponent, i4.SpinnerComponent, i4.FormErrorsComponent, i4.FormRequiredAsterisksComponent, i2$1.AsyncPipe, i2.UrlPipe, i2.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return OneTimePasswordRegisterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let OneTimePasswordRegisterModule = /*#__PURE__*/(() => {
  class OneTimePasswordRegisterModule {
    static {
      this.ɵfac = function OneTimePasswordRegisterModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OneTimePasswordRegisterModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: OneTimePasswordRegisterModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            RegisterCustomerWithOTPComponent: {
              component: OneTimePasswordRegisterComponent,
              guards: [NotAuthGuard],
              providers: [{
                provide: RegisterComponentService,
                useClass: RegisterComponentService,
                deps: [UserRegisterFacade, UntypedFormBuilder]
              }]
            }
          }
        })],
        imports: [CommonModule, RouterModule, UrlModule, PageSlotModule, I18nModule, FeaturesConfigModule, BtnLikeLinkModule, ReactiveFormsModule, NgSelectModule, NgSelectA11yModule, CaptchaModule, SpinnerModule, FormErrorsModule, FormRequiredAsterisksComponent]
      });
    }
  }
  return OneTimePasswordRegisterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const globalMsgShowTime = 10000;
let RegistrationVerificationTokenFormComponentService = /*#__PURE__*/(() => {
  class RegistrationVerificationTokenFormComponentService {
    constructor() {
      this.globalMessageService = inject(GlobalMessageService);
      this.userRegisterFacade = inject(UserRegisterFacade);
      this.featureConfigService = inject(FeatureConfigService);
    }
    displayMessage(key, params) {
      this.globalMessageService.add({
        key: key,
        params
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION, globalMsgShowTime);
    }
    register(user) {
      return this.userRegisterFacade.register(user);
    }
    postRegisterMessage() {
      if (this.featureConfigService.isEnabled('a11yPostRegisterSuccessMessage')) {
        this.displayMessage('register.postRegisterSuccessMessage', globalMsgShowTime);
      } else {
        this.globalMessageService.add({
          key: 'register.postRegisterMessage'
        }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      }
    }
    static {
      this.ɵfac = function RegistrationVerificationTokenFormComponentService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RegistrationVerificationTokenFormComponentService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RegistrationVerificationTokenFormComponentService,
        factory: RegistrationVerificationTokenFormComponentService.ɵfac
      });
    }
  }
  return RegistrationVerificationTokenFormComponentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let RegistrationVerificationTokenFormComponent = /*#__PURE__*/(() => {
  class RegistrationVerificationTokenFormComponent {
    constructor() {
      this.fb = inject(UntypedFormBuilder);
      this.router = inject(RoutingService);
      this.authConfigService = inject(AuthConfigService);
      this.registrationVerificationTokenFacade = inject(VerificationTokenFacade);
      this.service = inject(RegistrationVerificationTokenFormComponentService);
      this.globalMessage = inject(GlobalMessageService);
      this.launchDialogService = inject(LaunchDialogService);
      this.featureConfigService = inject(FeatureConfigService);
      this.passwordValidators = this.getPasswordValidators();
      this.cdr = inject(ChangeDetectorRef);
      this.waitTime = 60;
      this.waitTimeForRateLimit = 300;
      this.registerForm = this.fb.group({
        password: ['', [Validators.required, ...this.passwordValidators]],
        passwordconf: ['', Validators.required],
        tokenCode: ['', Validators.required],
        titleCode: [''],
        firstName: [''],
        lastName: [''],
        email: [''],
        tokenId: ['']
      }, {
        validators: CustomFormValidators.passwordsMustMatch('password', 'passwordconf')
      });
      this.isLoading$ = new BehaviorSubject(false);
      this.isResendDisabled = true;
    }
    getPasswordValidators() {
      if (this.featureConfigService?.isEnabled('formErrorsDescriptiveMessages')) {
        if (this.featureConfigService.isEnabled('enableSecurePasswordValidation')) {
          return CustomFormValidators.securePasswordValidators;
        } else {
          if (this.featureConfigService.isEnabled('enableConsecutiveCharactersPasswordRequirement')) {
            return [...CustomFormValidators.passwordValidators, CustomFormValidators.noConsecutiveCharacters];
          } else {
            return CustomFormValidators.passwordValidators;
          }
        }
      } else {
        if (this.featureConfigService.isEnabled('enableSecurePasswordValidation')) {
          return CustomFormValidators.securePasswordValidator;
        } else {
          return CustomFormValidators.passwordValidators;
        }
      }
    }
    ngOnInit() {
      if (!!history.state) {
        this.tokenId = history.state['tokenId'];
        this.target = history.state['loginId'];
        this.titleCode = history.state['titleCode'];
        this.firstName = history.state['firstName'];
        this.lastName = history.state['lastName'];
        this.errorStatus = history.state['errorStatus'];
        history.pushState({
          tokenId: '',
          loginId: '',
          titleCode: '',
          firstName: '',
          lastName: '',
          errorStatus: ''
        }, 'verifyTokenForRegistration');
      }
      if (this.errorStatus === 400) {
        this.upToRateLimit = true;
        this.tokenId = 'invalidTokenId';
        this.startRateLimitWaitTimeInterval();
      } else if (!this.target || !this.tokenId || !this.firstName || !this.lastName) {
        this.router.go(['/login/register']);
      } else {
        this.startWaitTimeInterval();
        this.service.displayMessage('verificationTokenForm.createVerificationToken', {
          target: this.target
        });
      }
    }
    onSubmit() {
      if (this.registerForm.valid) {
        this.registerUserWithVerificationToken();
      } else {
        this.registerForm.markAllAsTouched();
      }
    }
    registerUserWithVerificationToken() {
      this.isLoading$.next(true);
      this.registerForm.setValue({
        titleCode: this.titleCode,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.target,
        tokenId: this.tokenId,
        password: this.registerForm.value.password,
        tokenCode: this.registerForm.value.tokenCode,
        passwordconf: this.registerForm.value.passwordconf
      });
      this.service.register(this.collectDataFromRegisterForm(this.registerForm.value)).subscribe({
        next: () => this.onRegisterUserSuccess(),
        complete: () => this.isLoading$.next(false),
        error: error => {
          if (error.status === 400) {
            this.registerForm.get('tokenCode')?.setErrors({
              invalidTokenCodeError: error.message
            });
            this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
          }
          this.isLoading$.next(false);
        }
      });
    }
    collectDataFromRegisterForm(formData) {
      const {
        email,
        firstName,
        lastName,
        password,
        titleCode,
        tokenId: verificationTokenId,
        tokenCode: verificationTokenCode
      } = formData;
      return {
        uid: email.toLowerCase(),
        firstName,
        lastName,
        password,
        titleCode,
        verificationTokenId,
        verificationTokenCode
      };
    }
    onRegisterUserSuccess() {
      if (this.authConfigService.getOAuthFlow() === OAuthFlow.ResourceOwnerPasswordFlow) {
        this.router.go('login');
      }
      this.service.postRegisterMessage();
    }
    resendOTP() {
      this.isResendDisabled = true;
      this.resendLink.nativeElement.tabIndex = -1;
      this.waitTime = 60;
      this.startWaitTimeInterval();
      this.createRegistrationVerificationToken(this.target, ONE_TIME_PASSWORD_REGISTRATION_PURPOSE).subscribe({
        next: result => this.tokenId = result.tokenId,
        complete: () => this.service.displayMessage('verificationTokenForm.createVerificationToken', {
          target: this.target
        })
      });
    }
    createRegistrationVerificationToken(loginId, purpose) {
      return this.registrationVerificationTokenFacade.createVerificationToken({
        loginId,
        purpose
      });
    }
    startWaitTimeInterval() {
      const interval = setInterval(() => {
        this.waitTime--;
        this.cdr.detectChanges();
        if (this.waitTime <= 0) {
          clearInterval(interval);
          this.isResendDisabled = false;
          this.resendLink.nativeElement.tabIndex = 0;
          this.cdr.detectChanges();
        }
      }, 1000);
    }
    startRateLimitWaitTimeInterval() {
      const interval = setInterval(() => {
        this.waitTimeForRateLimit--;
        this.cdr.detectChanges();
        if (this.waitTimeForRateLimit <= 0) {
          clearInterval(interval);
          this.upToRateLimit = false;
          this.isResendDisabled = false;
          this.cdr.detectChanges();
        }
      }, 1000);
    }
    openInfoDailog() {
      this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.ACCOUNT_VERIFICATION_TOKEN, this.element);
    }
    onOpenInfoDailogKeyDown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.openInfoDailog();
      }
    }
    static {
      this.ɵfac = function RegistrationVerificationTokenFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RegistrationVerificationTokenFormComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RegistrationVerificationTokenFormComponent,
        selectors: [["cx-registration-verification-token-form"]],
        viewQuery: function RegistrationVerificationTokenFormComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c9, 5);
            i0.ɵɵviewQuery(_c10, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resendLink = _t.first);
          }
        },
        standalone: false,
        decls: 50,
        vars: 47,
        consts: [["loading", ""], ["resendLink", ""], ["noReceiveCodeLink", ""], [3, "ngSubmit", "formGroup"], [1, "label-content"], ["required", "true", "formControlName", "tokenCode", 1, "form-control", 3, "placeholder"], [3, "control"], ["class", "rate-limit-error-display", 4, "ngIf"], ["type", "hidden", "formControlName", "tokenId", 3, "ngModelChange", "ngModel"], ["class", "resend-link-text", 4, "ngIf"], [1, "form-group"], ["required", "true", "type", "password", "name", "password", "formControlName", "password", "aria-describedby", "password-input-hint", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], ["id", "password-input-hint", 1, "input-hint"], [3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "password", "name", "confirmpassword", "formControlName", "passwordconf", "cxPasswordVisibilitySwitch", "", 1, "form-control", 3, "placeholder"], [1, "verify-container"], ["type", "submit", 1, "btn", "btn-block", "btn-primary", 3, "disabled"], [1, "btn", "btn-block", "btn-secondary", "btn-register", 3, "routerLink"], [1, "rate-limit-error-display"], [1, "resend-link-text"], [1, "left-text"], ["role", "timer", "aria-live", "polite", "aria-atomic", "true"], ["role", "button", "tabindex", "-1", 1, "btn-link", 3, "keydown.enter", "keydown.space", "click", "ngClass"], [4, "ngIf"], [1, "right-text"], ["role", "button", "tabindex", "0", 1, "btn-link", 3, "keydown", "click"], [3, "translationParams", "control"], [1, "cx-spinner"]],
        template: function RegistrationVerificationTokenFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "form", 3);
            i0.ɵɵlistener("ngSubmit", function RegistrationVerificationTokenFormComponent_Template_form_ngSubmit_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSubmit());
            });
            i0.ɵɵelementStart(1, "label")(2, "span", 4);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "cxTranslate");
            i0.ɵɵelement(5, "cx-form-required-asterisks");
            i0.ɵɵtext(6, " >");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "input", 5);
            i0.ɵɵpipe(8, "cxTranslate");
            i0.ɵɵelement(9, "cx-form-errors", 6);
            i0.ɵɵtemplate(10, RegistrationVerificationTokenFormComponent_div_10_Template, 3, 6, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "input", 8);
            i0.ɵɵtwoWayListener("ngModelChange", function RegistrationVerificationTokenFormComponent_Template_input_ngModelChange_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.tokenId, $event) || (ctx.tokenId = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, RegistrationVerificationTokenFormComponent_div_12_Template, 13, 10, "div", 9);
            i0.ɵɵelementStart(13, "div", 10)(14, "label")(15, "span", 4);
            i0.ɵɵtext(16);
            i0.ɵɵpipe(17, "cxTranslate");
            i0.ɵɵelement(18, "cx-form-required-asterisks");
            i0.ɵɵtext(19, " >");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(20, "input", 11);
            i0.ɵɵpipe(21, "cxTranslate");
            i0.ɵɵpipe(22, "cxTranslate");
            i0.ɵɵelementStart(23, "p", 12);
            i0.ɵɵtext(24);
            i0.ɵɵpipe(25, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(26, RegistrationVerificationTokenFormComponent_cx_form_errors_26_Template, 2, 6, "cx-form-errors", 13)(27, RegistrationVerificationTokenFormComponent_cx_form_errors_27_Template, 1, 1, "cx-form-errors", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(28, "div", 10)(29, "label")(30, "span", 4);
            i0.ɵɵtext(31);
            i0.ɵɵpipe(32, "cxTranslate");
            i0.ɵɵelement(33, "cx-form-required-asterisks");
            i0.ɵɵtext(34, " >");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(35, "input", 15);
            i0.ɵɵpipe(36, "cxTranslate");
            i0.ɵɵpipe(37, "cxTranslate");
            i0.ɵɵtemplate(38, RegistrationVerificationTokenFormComponent_cx_form_errors_38_Template, 2, 6, "cx-form-errors", 13)(39, RegistrationVerificationTokenFormComponent_cx_form_errors_39_Template, 1, 1, "cx-form-errors", 14);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(40, "div", 16)(41, "button", 17);
            i0.ɵɵtext(42);
            i0.ɵɵpipe(43, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(44, "button", 18);
            i0.ɵɵpipe(45, "cxUrl");
            i0.ɵɵtext(46);
            i0.ɵɵpipe(47, "cxTranslate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(48, RegistrationVerificationTokenFormComponent_ng_template_48_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.registerForm);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 22, "verificationTokenForm.verificationCode.label"), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(8, 24, "verificationTokenForm.verificationCode.placeholder"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("control", ctx.registerForm.get("tokenCode"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.upToRateLimit);
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("ngModel", ctx.tokenId);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.upToRateLimit);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(17, 26, "register.password.label"), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(21, 28, "register.password.placeholder"));
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(22, 30, "register.password.placeholder"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(25, 32, "register.passwordMinRequirements"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(32, 34, "register.confirmPassword.label"), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(36, 36, "register.confirmPassword.placeholder"));
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(37, 38, "register.confirmPassword.placeholder"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.registerForm.disabled);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(43, 40, "register.register"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(45, 42, i0.ɵɵpureFunction0(46, _c11)));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(47, 44, "verificationTokenForm.back"), " ");
          }
        },
        dependencies: [i2$1.NgClass, i2$1.NgIf, i3.ɵNgNoValidate, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgControlStatusGroup, i3.RequiredValidator, i3.FormGroupDirective, i3.FormControlName, i5.RouterLink, i4.FormErrorsComponent, i4.SpinnerComponent, i2.FeatureDirective, i4.FormRequiredAsterisksComponent, i2.UrlPipe, i2.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return RegistrationVerificationTokenFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let RegistrationVerificationTokenFormModule = /*#__PURE__*/(() => {
  class RegistrationVerificationTokenFormModule {
    static {
      this.ɵfac = function RegistrationVerificationTokenFormModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RegistrationVerificationTokenFormModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: RegistrationVerificationTokenFormModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            VerifyOTPForRegistrationComponent: {
              component: RegistrationVerificationTokenFormComponent,
              guards: [NotAuthGuard],
              providers: [{
                provide: RegistrationVerificationTokenFormComponentService,
                useClass: RegistrationVerificationTokenFormComponentService,
                deps: [GlobalMessageService, UserRegisterFacade]
              }]
            }
          }
        })],
        imports: [CommonModule, FormsModule, KeyboardFocusModule, ReactiveFormsModule, RouterModule, UrlModule, IconModule, I18nModule, FormErrorsModule, SpinnerModule, FeaturesConfigModule, FormRequiredAsterisksComponent]
      });
    }
  }
  return RegistrationVerificationTokenFormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UserProfileComponentsModule = /*#__PURE__*/(() => {
  class UserProfileComponentsModule {
    static {
      this.ɵfac = function UserProfileComponentsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserProfileComponentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: UserProfileComponentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [RegisterComponentModule, UpdateProfileModule, UpdateEmailModule, UpdatePasswordModule, ForgotPasswordModule, ResetPasswordModule, CloseAccountModule, AddressBookModule, OneTimePasswordRegisterModule, RegistrationVerificationTokenFormModule]
      });
    }
  }
  return UserProfileComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddressBookComponent, AddressBookComponentService, AddressBookModule, AddressFormComponent, AddressFormModule, CloseAccountComponent, CloseAccountModalComponent, CloseAccountModule, ForgotPasswordComponent, ForgotPasswordComponentService, ForgotPasswordModule, MyAccountV2EmailComponent, MyAccountV2PasswordComponent, MyAccountV2ProfileComponent, OneTimePasswordRegisterComponent, OneTimePasswordRegisterModule, RegisterComponent, RegisterComponentModule, RegisterComponentService, RegistrationVerificationTokenFormComponent, RegistrationVerificationTokenFormComponentService, RegistrationVerificationTokenFormModule, ResetPasswordComponent, ResetPasswordComponentService, ResetPasswordModule, SuggestedAddressDialogComponent, USE_MY_ACCOUNT_V2_EMAIL, USE_MY_ACCOUNT_V2_PASSWORD, USE_MY_ACCOUNT_V2_PROFILE, UpdateEmailComponent, UpdateEmailComponentService, UpdateEmailModule, UpdatePasswordComponent, UpdatePasswordComponentService, UpdatePasswordModule, UpdateProfileComponent, UpdateProfileComponentService, UpdateProfileModule, UserProfileComponentsModule };
